import type { Translations } from './types';

const es: Translations = {
  nav: {
    approvals: 'Aprobaciones',
    home: 'Inicio',
    search: 'Buscar',
    dashboard: 'Panel',
    outdoors: 'Vallas',
    campaigns: 'Campañas',
    admin: 'Admin',
    logIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    logOut: 'Cerrar sesión',
    account: 'Cuenta',
    setupBusiness: 'Configurar Empresa',
    searchOutdoors: 'Buscar Vallas',
    manageOutdoors: 'Gestionar Vallas',
    verifyOutdoors: 'Verificar Vallas',
    adminPanel: 'Panel de Administración',
    upcomingCampaigns: 'Próximas Campañas',
    getPaid: 'Cobrar',
    revenue: 'Ingresos',
    payments: 'Pagos',
  },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Volver',
    next: 'Siguiente',
    done: 'Hecho',
    loading: 'Cargando…',
    error: 'Algo salió mal',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    clear: 'Limpiar',
    edit: 'Editar',
    add: 'Añadir',
    search: 'Buscar',
    view: 'Ver',
    create: 'Crear',
    update: 'Actualizar',
    submit: 'Enviar',
    yes: 'Sí',
    no: 'No',
    close: 'Cerrar',
    upload: 'Subir',
    uploading: 'Subiendo…',
    saving: 'Guardando…',
    creating: 'Creando…',
    noResults: 'Sin resultados',
    required: 'Obligatorio',
    optional: 'Opcional',
    copy: 'Copiar',
    copied: '¡Copiado!',
    approve: 'Aprobar',
    reject: 'Rechazar',
    page: 'Página',
    of: 'de',
    perDay: '/día',
    days: '{{count}} día',
    days_plural: '{{count}} días',
    termsAndConditions: 'Términos y Condiciones',
    selectCountry: 'Seleccionar un país...',
    noCountriesFound: 'No se encontraron países',
    notSet: 'No establecido',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    refresh: 'Actualizar',
    new: 'Nuevo',
    rowsPerPage: 'Filas por página',
  },
  home: {
    tagline: 'Tu marketplace OOH orientado a la visibilidad',
    heroTitle: 'Tu marca alcanzando nuevas alturas',
    heroSubtitle:
      'Scapow conecta propietarios de vallas con anunciantes. Explora espacios reales, planifica campañas y llega a tu audiencia - todo en un solo lugar.',
    browseOutdoors: 'Explorar Vallas',
    getStartedFree: 'Comenzar Gratis',
    featuredOutdoors: 'Vallas Destacadas',
    viewAll: 'Ver todas →',
    howItWorksTitle: 'Cómo funciona',
    howItWorksSubtitle: 'Tres sencillos pasos para poner tu mensaje ante el público adecuado.',
    step1Title: 'Encuentra el espacio perfecto',
    step1Desc:
      'Busca vallas por ubicación, tamaño y precio. Filtra por disponibilidad en tus fechas.',
    step2Title: 'Crea tu campaña',
    step2Desc:
      'Añade múltiples vallas a una campaña, sube tus creatividades y obtén los detalles de pago.',
    step3Title: 'Sigue tus resultados',
    step3Desc:
      'Monitoriza el progreso de la campaña, el estado de los banners y las métricas de rendimiento desde tu panel.',
    builtTitle: 'Hecho para ambos lados',
    builtSubtitle:
      'Ya seas propietario de vallas o anunciante, Scapow tiene lo que necesitas.',
    feature1Title: 'Lista tus vallas',
    feature1Desc:
      'Publica fácilmente tus vallas, establece precios, añade fotos y controla la disponibilidad.',
    feature2Title: 'Búsqueda en el mapa',
    feature2Desc:
      'Encuentra vallas en un mapa en tiempo real. Acerca para menor radio, aleja para mayor alcance.',
    feature3Title: 'Gestión de campañas',
    feature3Desc:
      'Crea campañas con múltiples vallas, sube creatividades y paga por transferencia bancaria.',
    feature4Title: 'Empresas verificadas',
    feature4Desc: 'Todas las empresas son verificadas con documentos antes de publicar.',
    feature5Title: 'Seguimiento del rendimiento',
    feature5Desc:
      'Anunciantes y proveedores obtienen resúmenes de ingresos y actividad en su panel.',
    feature6Title: 'Precios transparentes',
    feature6Desc: 'Tarifas del proveedor mostradas por día - siempre visibles antes de confirmar.',
    ctaTitle: '¿Listo para empezar?',
    ctaSubtitle: 'Únete a Scapow hoy y empieza a conectar con el mercado de publicidad exterior.',
    createAccount: 'Crear Cuenta',
    browseFirst: 'Explorar Primero',
    nearbyOutdoors: 'Vallas Cerca de Ti',
    detectingLocation: 'Detectando tu ubicación…',
    basedOnLocation: 'Basado en tu ubicación actual',
    welcomeBack: 'Bienvenido, {{name}}',
    fromCompany: 'de {{company}}',
    ppPrompt: '¿Todos tus outdoors están listos para nuevas Campañas?',
    advertiserPrompt: '¿Estás listo para crear algunas Campañas?',
    noCompanyPrompt: 'Configura tu empresa para desbloquear todas las funcionalidades.',
    goToDashboard: 'Ir al Panel',
    inviteFrom: '{{company}} te ha invitado a unirte a su equipo en Scapow.',
    inviteFromDesc: 'Acepta para comenzar a colaborar en campañas de publicidad exterior.',
    inviteAccept: 'Aceptar Invitación',
    inviteDecline: 'Declinar',
    inviteAccepted: '¡Bienvenido/a! Te has unido con éxito a {{company}}.',
    inviteDeclined: 'Has declinado la invitación.',
    ppHowItWorksSubtitle: 'Todo lo que necesitas para convertir tus espacios exteriores en una fuente de ingresos constante.',
    ppStep1Title: 'Muestra tus espacios',
    ppStep1Desc: 'Lista tus vallas con fotos atractivas, dimensiones precisas y precios competitivos - para que los anunciantes vean su valor al instante.',
    ppStep2Title: 'Sé descubierto por las marcas',
    ppStep2Desc: 'Tus vallas aparecen en las búsquedas de anunciantes que planifican su próxima campaña. La campaña correcta te encuentra.',
    ppStep3Title: 'Demuéstralo y cobra',
    ppStep3Desc: 'Sube pruebas fotográficas una vez que tu valla esté montada y en marcha. El pago se procesa automáticamente tras la aprobación.',
  },
  auth: {
    login: {
      heroTitle: 'Conecta tu marca con el mundo. Una nueva altura a la vez.',
      heroSubtitle:
        'La plataforma que une propietarios de vallas con anunciantes - sencilla, rápida e impactante.',
      title: 'Bienvenido de nuevo',
      subtitle: 'Inicia sesión para continuar',
      email: 'Dirección de correo',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste la contraseña?',
      resendVerification: 'Reenviar email de verificación',
      signIn: 'Iniciar sesión',
      noAccount: '¿No tienes cuenta?',
      createOne: 'Crear una',
      invalidCredentials: 'Email o contraseña incorrectos. Inténtalo de nuevo.',
    },
    register: {
      heroTitle: 'Únete a la revolución de la publicidad exterior',
      heroSubtitle:
        'Ya seas propietario de vallas o anunciante, Scapow lo hace sencillo.',
      title: 'Crea tu cuenta',
      subtitle: 'Empieza a gestionar campañas de publicidad exterior hoy',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Dirección de correo',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      passwordHint: 'Mínimo 8 caracteres',
      createAccount: 'Crear cuenta',
      alreadyHaveAccount: '¿Ya tienes cuenta?',
      signIn: 'Iniciar sesión',
      checkEmail: 'Comprueba tu correo',
      checkEmailDesc:
        'Hemos enviado un enlace de verificación a tu dirección de correo. Haz clic en él para activar tu cuenta.',
      goToLogin: 'Ir al inicio de sesión',
      termsAgreement: 'He leído y acepto los',
      termsLink: 'Términos y Condiciones',
    },
    forgotPassword: {
      title: 'Recuperar contraseña',
      subtitle: 'Introduce tu correo y te enviaremos un enlace de recuperación',
      email: 'Dirección de correo',
      sendReset: 'Enviar enlace de recuperación',
      backToLogin: 'Volver al inicio de sesión',
      checkEmail: 'Comprueba tu correo',
      checkEmailDesc:
        'Si esa dirección está registrada, recibirás un enlace de recuperación en breve.',
    },
    resetPassword: {
      title: 'Establecer nueva contraseña',
      subtitle: 'Elige una contraseña segura que recuerdes.',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      save: 'Guardar nueva contraseña',
      submit: 'Actualizar contraseña',
    },
    verifyEmail: {
      verifying: 'Verificando tu correo…',
      success: '¡Correo verificado!',
      successDesc: 'Tu cuenta ya está activa. Puedes iniciar sesión.',
      error: 'Verificación fallida',
      errorDesc: 'El enlace puede estar caducado o ser inválido. Por favor regístrate de nuevo.',
      goToLogin: 'Ir al inicio de sesión',
      successDescBusiness: 'Tu cuenta ya está activa. Puedes iniciar sesión y configurar tu empresa.',
      returnToLogin: 'Volver al inicio de sesión',
      resendButton: 'Solicitar nuevo enlace de verificación',
    },
    resendVerification: {
      title: 'Reenviar email de verificación',
      subtitle: 'Introduce tu correo y te enviaremos un nuevo enlace de verificación.',
      email: 'Dirección de correo',
      send: 'Enviar email de verificación',
      backToLogin: 'Volver al inicio de sesión',
      checkEmail: 'Revisa tu correo',
      checkEmailDesc: 'Si tu cuenta está pendiente de verificación, te hemos enviado un nuevo enlace a tu bandeja de entrada.',
    },
  },
  business: {
    pendingVerification: 'Su cuenta empresarial está actualmente en proceso de validación. Una vez que nuestro equipo complete la verificación, tendrá acceso completo a todas las funciones de Scapow. Mientras tanto, le recomendamos estar atento a su bandeja de entrada - podríamos contactarle si se requiere documentación adicional.',
    setup: {
      title: 'Configura tu Empresa',
      subtitle: 'Vincula tu cuenta a una entidad empresarial para empezar a usar Scapow.',
      ppTitle: 'Proveedor de Espacios',
      ppDesc: 'Tengo espacios de publicidad exterior y quiero alquilarlos.',
      advertiserTitle: 'Anunciante',
      advertiserDesc: 'Quiero reservar campañas de publicidad exterior.',
      changeType: 'Cambiar ↩',
      createCompany: 'Crear nueva empresa',
      createCompanyDesc: 'Registra tu empresa en Scapow.',
      joinCompany: 'Unirse a empresa existente',
      joinCompanyDesc: 'Solicita acceso a una empresa ya registrada.',
      registerTitle: 'Registrar tu empresa',
      companyName: 'Nombre de la empresa',
      vatNumber: 'Número de NIF/CIF',
      companyEmail: 'Email de la empresa',
      currency: 'Moneda preferida',
      currencyHint: 'Código ISO de moneda, ej: EUR, USD, GBP',
      country: 'País',
      proofDocument: 'Documento acreditativo de empresa',
      proofHint: 'PDF, JPG o PNG',
      uploadProof: 'Haz clic para subir el comprobante de empresa',
      createCompanyBtn: 'Crear empresa',
      bankTitle: 'Datos bancarios',
      bankSubtitlePP: 'Su IBAN y SWIFT/BIC se utilizarán para los pagos cuando sus campañas exteriores estén activas.',
      bankSubtitleAdvertiser: 'Su IBAN y SWIFT/BIC se utilizarán para procesar reembolsos cuando sea aplicable.',
      findTitle: 'Encuentra tu empresa',
      searchPlaceholder: 'Buscar por nombre de empresa…',
      noCompanies: 'No se encontraron empresas. Busca por nombre.',
      requestAccess: 'Solicitar acceso',
      requested: 'Solicitado',
      accessSentMsg:
        '¡Solicitud de acceso enviada! Un administrador de la empresa debe aprobarla. Serás notificado cuando se apruebe.',
      pendingTitle: 'Solicitud de acceso pendiente',
      pendingDesc: 'Tu solicitud para unirte a {{name}} está siendo revisada. Serás notificado cuando se apruebe.',
      cancelRequest: 'Cancelar solicitud',
      requestCancelled: 'Solicitud de acceso cancelada.',
      connectingToEntity: 'Conectando con tu organización…',
      accessApproved: '¡Tu solicitud de acceso fue aprobada! Ya formas parte del equipo.',
      accessRejected: 'Tu solicitud de acceso fue rechazada. Por favor, crea o únete a otra entidad empresarial.',
      orSetupYourOwn: 'O registra tu empresa o únete a una existente a continuación.',
      invitationsTitle: 'Invitaciones Pendientes',
      invitationsSubtitle: 'Has sido invitado a unirte a un negocio. Acepta o rechaza a continuación.',
      invitedOn: 'Invitado el',
      acceptInvitation: 'Aceptar',
      declineInvitation: 'Rechazar',
      invitationAccepted: '¡Invitación aceptada! Conectando con tu organización…',
      invitationDeclined: 'Invitación rechazada.',
    },
    details: {
      title: 'Detalles de la Empresa',
      subtitle: 'Gestiona el registro y la información bancaria de tu empresa.',
      registrationTitle: 'Datos de registro',
      companyName: 'Nombre de la empresa',
      vatNumber: 'Número de NIF/CIF',
      companyEmail: 'Email de la empresa',
      currency: 'Moneda preferida',
      country: 'País',
      portugueseRegion: 'Región portuguesa',
      regionContinent: 'Continente',
      regionAzores: 'Azores',
      regionMadeira: 'Madeira',
      replaceProof: 'Reemplazar documento acreditativo',
      uploadProof: 'Haz clic para subir un nuevo documento acreditativo',
      saveChanges: 'Guardar cambios',
      addressSectionTitle: 'Dirección',
      addressLine: 'Dirección',
      addressLinePlaceholder: 'Calle Mayor 123',
      city: 'Ciudad',
      postCode: 'Código postal',
      state: 'Estado',
      stateHint: 'Obligatorio para cuentas de pago en USD',
      selectState: 'Selecciona un estado',
      bankTitle: 'Datos bancarios',
      bankSubtitle: 'Utilizado para recibir pagos de los anunciantes.',
      bankSubtitlePP: 'Su IBAN y SWIFT/BIC se utilizan para los pagos cuando las campañas están activas.',
      bankSubtitleAdvertiser: 'Su IBAN y SWIFT/BIC se utilizan para reembolsos cuando corresponda.',
      bankClickUnlock: 'Bloqueado - haga clic para editar',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: 'Número de Cuenta Bancaria Internacional...',
      swiftHint: '8 o 11 caracteres: código del banco (4) + país (2) + ubicación (2) + sucursal opcional (3)',
      accountNumber: 'Número de cuenta',
      accountNumberHint: 'Tu número de cuenta bancaria en EE. UU. (4–17 dígitos)',
      saveBankDetails: 'Guardar datos bancarios',
      verifiedLocked: 'El nombre de la empresa, el número de IVA y el país están bloqueados tras la verificación.',
      verifiedBadge: 'Verificado',
      pendingReviewTitle: 'Pendiente de Aprobación',
      pendingReviewDesc: 'Tu registro empresarial está siendo revisado. Tendrás acceso completo a la plataforma en cuanto nuestro equipo lo apruebe - te notificaremos en tiempo real.',
      verifiedTitle: 'Identidad Verificada',
      verifiedDesc: 'La identidad de su empresa ha sido confirmada. No se requiere documentación adicional.',
      proofCardTitle: 'Documento de Verificación',
      proofCardDesc: 'Suba el documento de registro de su empresa para respaldar la verificación de su cuenta. Nuestro equipo lo revisará y se pondrá en contacto si necesita algo más.',
      proofCardSubmit: 'Enviar para revisión',
      proofCardSuccess: 'Documento enviado correctamente. Nuestro equipo lo revisará y se pondrá en contacto si es necesario.',
      proofCardValidatingTitle: 'Documentos en revisión',
      proofCardValidatingDesc: 'Sus documentos de verificación han sido recibidos y están siendo revisados por nuestro equipo. Le notificaremos en cuanto el proceso haya concluido.',
      proofCardProcessingTitle: 'Procesando archivo',
      proofCardProcessingDesc: 'Hemos recibido su documento y lo estamos verificando automáticamente. No tardará mucho.',
      proofCardReplaceFile: '¿Subió el archivo equivocado? Reemplácelo',
    },
  },
  search: {
    instantBookingHint: 'Confirmación inmediata, sin esperar la aprobación del proveedor',
    priceFilterLocked: 'Los filtros de precio están disponibles una vez que inicie sesión y esté vinculado a una entidad empresarial.',
    title: 'Buscar Vallas',
    subtitle: 'Encuentra espacios publicitarios en el mapa',
    filters: 'Filtros',
    minWidth: 'Anchura mínima (m)',
    maxWidth: 'Anchura máxima (m)',
    minHeight: 'Altura mínima (m)',
    maxHeight: 'Altura máxima (m)',
    minPrice: 'Precio mínimo (€/día)',
    maxPrice: 'Precio máximo (€/día)',
    providerName: 'Nombre del proveedor',
    clearFilters: 'Limpiar filtros',
    noResults: 'No se encontraron vallas en esta área',
    noResultsDesc: 'Prueba a ampliar el área en el mapa, ajustar los filtros o extender la duración de la campaña para ampliar la disponibilidad.',
    addToCart: 'Añadir al carrito',
    inCart: 'En el carrito',
    selectDates: 'Seleccionar fechas',
    from: 'Desde',
    to: 'Hasta',
    results: 'resultados',
    loading: 'Cargando vallas…',
    resultsTab: 'Resultados ({{count}})',
    mapTab: 'Mapa',
    searching: 'Buscando…',
    found: '{{count}} valla encontrada',
    found_plural: '{{count}} vallas encontradas',
    moveMap: 'Mueve el mapa para actualizar los resultados',
    noticePeriodHint: 'Algunos proveedores de espacios requieren un período mínimo de aviso antes de que pueda comenzar una campaña, o un período mínimo de alquiler, lo que puede afectar la disponibilidad y los resultados de búsqueda.',
    noOutdoorsFound: 'No se encontraron espacios publicitarios',
    noOutdoorsFoundAdjustDates: 'Intenta ajustar las fechas de inicio y fin, o aleja el zoom.',
    noOutdoorsFoundAdjustFilters: 'Aleja el zoom o ajusta tus filtros.',
    inCampaign: 'En campaña',
    attributes: 'Ubicado cerca de',
    withDiscounts: 'Descuentos por volumen disponibles',
    illuminated: 'Solo iluminados',
    illuminatedHint: 'el espacio tiene iluminación (p. ej., durante la noche)',
    containsDiscounts: 'Descuentos por volumen',
    containsDiscountsDesc: 'Este espacio ofrece precios escalonados - cuantos más días reserves, menor será la tarifa diaria.',
  },
  outdoor: {
    startAtMonthFirstDay: 'Empezar el día 1 del mes',
    startAtMonthFirstDayHint: 'Las reservas deben empezar el día 1 de un mes. Con solo meses completos, se hacen por meses naturales completos (del día 1 al último).',
    acceptingToastOn: '{{name}} ya acepta nuevas campañas.',
    acceptingToastOff: '{{name}} está en pausa: oculto en la búsqueda y cerrado a nuevas reservas.',
    acceptingToastBulkOn: '{{count}} espacio(s) aceptan ahora nuevas campañas.',
    acceptingToastBulkOff: '{{count}} espacio(s) en pausa: ocultos en la búsqueda y cerrados a nuevas reservas.',
    fullMonthRequired: 'Solo meses completos',
    fullMonthRequiredHint: 'Los anunciantes reservan por meses: desde su día de inicio hasta el mismo día del mes siguiente (empezando el día 1, hasta el último día del mes), durante tantos meses consecutivos como quieran.',
    fullMonthTooltip: 'Se reserva por meses: desde el día de inicio hasta el mismo día de un mes siguiente.',
    stepsTitle: 'Configuración del espacio',
    stepNotSet: 'Sin definir',
    stepLocationSet: 'Ubicación marcada',
    stepNoticeSummary: 'Preaviso: {{count}} día(s)',
    stepPhotosSummary: 'Fotos: {{count}}',
    stepPhotosNone: 'Aún sin fotos',
    stepBlockedSummary: 'Periodos bloqueados: {{count}}',
    stepOptional: 'Opcional',
    stepFeaturesSummary: 'Seleccionadas: {{count}}',
    fixHighlightedFields: 'Hay datos que corregir: hemos abierto el paso con el problema.',
    instantBooking: 'Reserva inmediata',
    instantBookingTooltip: 'Se reserva al instante, sin esperar la confirmación del proveedor.',
    instantBookingHint: 'Los anunciantes reservan este espacio al instante, sin esperar su aprobación. Déjelo desactivado para revisar cada reserva antes.',
    kmAway: 'a {{distance}} km',
    productionCost: 'Coste de producción',
    productionCostIncludes: 'incluye gastos de impresión, instalación, etc.',
    priceHiddenTitle: 'Valores diarios para cuentas de empresa',
    priceHiddenMessage: 'Inicie sesión y asegúrese de estar vinculado a una entidad empresarial (proveedor de espacios o anunciante) para ver el valor diario del espacio.',
    manageTitle: 'Gestionar Vallas',
    addNew: 'Añadir Nueva Valla',
    noOutdoors: 'Sin vallas todavía',
    noOutdoorsDesc: 'Añade tu primera valla para empezar a recibir reservas.',
    addFirst: 'Añade tu primera valla',
    editTitle: 'Editar Valla',
    createTitle: 'Añadir Nueva Valla',
    listSubtitle: 'Publica tu valla en Scapow.',
    editSubtitle: 'Actualiza los detalles de tu valla.',
    location: 'Ubicación',
    latitude: 'Latitud',
    longitude: 'Longitud',
    name: 'Nombre',
    namePlaceholder: 'ej: Gran Vía – Valla A',
    description: 'Descripción',
    descriptionPlaceholder: 'Valla premium en Gran Vía, zona de alto tráfico…',
    dimensions: 'Dimensiones y Especificaciones',
    width: 'Anchura (m)',
    height: 'Altura (m)',
    length: 'Longitud (m)',
    aspectRatio: 'Proporción del creativo',
    aspectRatioHint: 'Calculado automáticamente desde anchura ÷ altura',
    bleed: 'Margen de corte (m)',
    bleedHint: 'Área de impresión más allá del borde de corte final, que garantiza bordes limpios tras el corte.',
    illuminated: 'Iluminado',
    illuminatedHint: 'Este espacio publicitario tiene iluminación, manteniéndolo visible durante la noche.',
    currency: 'Moneda',
    currencyLockedHint: 'Definida por la moneda de tu cuenta de Proveedor de Espacios.',
    pricing: 'Precios',
    excludeVat: 'excluye IVA',
    vatIncluded: 'IVA incluido',
    pricePerDay: 'Precio por día',
    volumeDiscounts: 'Descuentos por volumen',
    addDiscount: 'Añadir',
    daysArrow: 'días →',
    percentOff: '% dto.',
    photos: 'Fotos de la ubicación',
    photosHint: 'Las fotos se guardan automáticamente al subirlas o eliminarlas.',
    uploadPhotos: 'Haz clic para subir fotos de la ubicación',
    addMorePhotos: 'Añadir más fotos',
    currentPhotos: 'Fotos actuales',
    uploadingPhotos: 'Subiendo fotos...',
    photosUploaded: 'Fotos subidas correctamente',
    deletePhotoTitle: '¿Eliminar foto?',
    deletePhotoConfirm: 'Esta foto se eliminará permanentemente de este outdoor.',
    filesSelected_one: '{{count}} archivo seleccionado',
    filesSelected_other: '{{count}} archivos seleccionados',
    blockedTimes: 'Períodos bloqueados',
    blockedTimesDesc:
      'Bloquea fechas en las que la valla no está disponible (mantenimiento, pre-reservas externas, etc.).',
    blockedTimesOverlapNote: 'Los rangos no pueden solaparse entre sí ni con reservas de campañas activas.',
    blockFrom: 'Bloquear desde',
    blockUntil: 'Bloquear hasta',
    addBlockedTime: 'Añadir período bloqueado',
    noBlockedTimes: 'Sin períodos bloqueados',
    occupiedByCampaign: 'Reservado por una campaña',
    unsaved: 'Sin guardar',
    unsavedChanges: '{{count}} cambio(s) sin guardar - guarde el outdoor para aplicar',
    selectBlockedDates: 'Por favor seleccione una fecha de inicio y una fecha de fin.',
    legalDeclaration: 'Declaro que tengo derechos legales sobre este espacio publicitario, que estoy autorizado a publicarlo comercialmente y que ello cumple con todas las leyes, permisos y normativas aplicables.',
    legalDeclarationRequired: 'Debe confirmar que tiene derechos legales sobre este espacio antes de publicarlo.',
    createOutdoor: 'Crear valla',
    saveChanges: 'Guardar cambios',
    deleteTitle: 'Eliminar Valla',
    deleteConfirm: '¿Estás seguro de que quieres eliminar esta valla? Esta acción no se puede deshacer.',
    hidden: 'Oculta',
    visible: 'Visible',
    viewDetails: 'Ver detalles',
    bookingRules: 'Reglas de reserva',
    bookingRulesDesc: 'Define los requisitos de antelación que los anunciantes deben cumplir antes de la fecha de inicio de la campaña.',
    minimumNoticeDays: 'Antelación mínima (días)',
    minimumNoticeDaysHint: 'Las campañas deben estar completamente pagadas y el creativo subido al menos este número de días antes de la fecha de inicio.',
    minimumDays: 'Duración mínima de alquiler (días)',
    minimumDaysHint: 'El número mínimo de días que los anunciantes deben alquilar este espacio.',
    acceptingCampaigns: 'Aceptando nuevas campañas',
    acceptingCampaignsOn: 'Este outdoor es visible en la búsqueda y se puede añadir a campañas.',
    acceptingCampaignsOff: 'Este outdoor está oculto en la búsqueda y no recibirá nuevas reservas.',
    acceptingBadge: 'Aceptando campañas',
    notAcceptingBadge: 'No acepta campañas',
    notAcceptingMsg: 'Este outdoor no está aceptando nuevas campañas en este momento.',
    unavailableForDates: 'Este outdoor no está disponible para las fechas seleccionadas.',
    paused: 'Pausado',
    accepting: 'Aceptando',
    availabilityToggleTooltip: 'Si este outdoor está disponible para campañas o no. Estado actual: {{state}}',
    availabilityStateOn: 'Disponible',
    availabilityStateOff: 'No disponible',
    toggleError: 'Error al actualizar la visibilidad de la campaña.',
    bulkAccept: 'Activar aceptación de campañas para todos los exteriores de esta página',
    bulkPause: 'Pausar aceptación de campañas para todos los exteriores de esta página',
    commissionNote: 'Los anunciantes verán el precio de <bold>{{currency}} {{advertiserPrice}}/día</bold> - su {{currency}} {{basePrice}} más una <bold>comisión Scapow del {{rate}}%</bold>.',
    advertiserPaysLabel: 'El anunciante paga',
    advertiserPaysDesc: 'Incluye {{rate}}% de comisión Scapow',
    youReceiveLabel: '{{name}} recibe',
    youReceiveDesc: 'Tras la tarifa del {{rate}}% de la plataforma (puede aplicarse IVA sobre la comisión)',
    searchByAddress: 'Buscar por dirección',
    dragPin: 'Arrastra el pin para ajustar la posición exacta.',
    myOutdoors: 'Mis Vallas',
    myOutdoorsSubtitle: 'Gestiona tu inventario de vallas',
    viewCalendarTooltip: 'Consulta las fechas bloqueadas de este Outdoor',
    calendarModalTitle: 'Calendario - {{name}}',
    addOutdoor: 'Añadir Valla',
    searchByName: 'Buscar por nombre…',
    deleteConfirmNamed: '¿Estás seguro de que quieres eliminar "{{name}}"? Esta acción no se puede deshacer.',
    specifications: 'Especificaciones',
    creativeRatio: 'Proporción del creativo',
    coordinates: 'Coordenadas',
    price: 'Precio',
    plusVat: '+ IVA',
    unavailableDates: 'Fechas no disponibles',
    duration: 'Duración',
    addToCampaign: 'Añadir a Campaña',
    goToCampaign: 'Ir a la Campaña',
    signInToAdd: 'Inicie sesión/Regístrese para añadir este Outdoor a su Campaña',
    bookingsCalendarTitle: 'Calendario de reservas',
    bookingsCalendarSubtitle: 'Vea cuándo sus campañas empiezan, están activas y terminan. Elija un día para ver qué espacios están reservados.',
    legend_starting: 'Inicio de campaña',
    legend_startingDesc: 'Una reserva sale al aire',
    legend_running: 'Campaña activa',
    legend_runningDesc: 'Su espacio está en emisión',
    legend_finishing: 'Fin de campaña',
    legend_finishingDesc: 'Último día de una reserva',
    legend_blocked: 'Fechas bloqueadas',
    legend_blockedDesc: 'Espacios que marcó como no disponibles',
    legend_none: 'Sin reservas',
    legend_noneDesc: 'Ninguno de sus espacios está reservado',
    legend_mixed: 'Colores divididos: ese día aplica más de uno',
    calendarToday: 'Hoy',
    selectDayHint: 'Elija un día para ver sus reservas. Vuelva a hacer clic para quitarlo.',
    clearDateSelection: 'Quitar fecha seleccionada',
    dailyStatesError: 'No se pudieron cargar las reservas de este mes. Intente actualizar.',
    searchBookedByName: 'Buscar espacios reservados por nombre…',
    clearSearch: 'Borrar búsqueda',
    bookedOutdoorsCount: 'Espacios reservados: {{count}}',
    noBookingsOnDate: 'Ningún espacio reservado este día',
    noBookedOutdoorsMatch: 'Ningún espacio reservado coincide con «{{name}}» este día',
    noBookingsOnDateHint: 'Elija otro día o quite la fecha para ver todos sus espacios.',
    bookingPeriod: 'Periodo de reserva',
    logIn: 'Iniciar sesión',
    register: 'Registrarse',
    selectCampaignToAdd: 'Por favor, seleccione una campaña para añadir este espacio',
    changeCampaign: 'Cambiar',
    alreadyInCampaign: 'Ya en campaña',
    billboardFallback: 'Valla Publicitaria',
    bookMoreThanDays: 'Reserva más de {{count}} días',
    percentageOff: '{{percentage}}% de descuento',
    comingSoon: '¡Tus Vallas estarán aquí pronto!',
    attributes: 'Ubicado cerca de',
    attributesHint: 'Ayuda a los anunciantes a encontrarte antes. Marca lo que hay cerca para mejorar la visibilidad de tu valla en los resultados de búsqueda.',
  },
  outdoorDetail: {
    productionCost: 'Coste de producción',
    bookingTitle: 'Reservar esta valla',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    estimatedCost: 'Coste estimado',
    addToCart: 'Añadir al carrito',
    inCart: 'Ya en el carrito',
    specs: 'Especificaciones',
    dimensions: 'Dimensiones',
    aspectRatio: 'Proporción requerida',
    pricePerDay: 'Precio por día',
    location: 'Ubicación',
    blockedTimes: 'Períodos bloqueados',
    discounts: 'Descuentos por volumen',
    noBlockedTimes: 'Sin períodos bloqueados',
    noDiscounts: 'Sin descuentos disponibles',
    photos: 'Fotos',
    days: 'días',
    total: 'Total',
    discount: 'descuento',
    campaignBookings: 'Reservas de Campaña',
    inCampaign: 'En Campaña',
    minimumNoticeInDays: 'Aviso mínimo de reserva',
  },
  campaign: {
    methodFlowLabel: 'Cómo pagará',
    methodFirstPayment: '1.er pago',
    methodCard: 'Tarjeta',
    methodThenMonthly: 'Después, cada mes',
    methodThenTrimonthly: 'Después, cada 3 meses',
    methodDirectDebit: 'Domiciliación bancaria',
    searchByName: 'Buscar campañas por nombre…',
    clearSearch: 'Borrar búsqueda',
    resultsSummary: 'Resultados: {{total}} · Página {{page}} de {{pages}}',
    noSearchResults: 'Ninguna campaña coincide con «{{name}}»',
    noSearchResultsHint: 'Revise la ortografía o pruebe con otro nombre.',
    eventFeedbackReceived: 'Un proveedor ha respondido sobre los espacios de su campaña.',
    eventConfirmationUpdated: 'La confirmación de su campaña ha finalizado: consulte su nuevo estado.',
    eventViewCampaign: 'Ver campaña',
    planTrimonthlyTitle: 'Pagar cada 3 meses',
    planTrimonthlyDesc: 'Pague ahora los costes de producción y los 3 primeros meses. Cada trimestre siguiente se cobra por domiciliación el primer día.',
    visitCampaignPage: 'Ver página de la campaña',
    payStepNotice: 'La disponibilidad de los espacios se vuelve a comprobar al pagar: si algo cambia, se lo indicaremos antes de cobrar.',
    removeOutdoor: 'Quitar este espacio',
    noOutdoorsYetDesc: 'Explore el mapa para encontrar espacios para su campaña y elija sus fechas.',
    creativesNeedOutdoors: 'Añada espacios primero: las creatividades necesarias dependen de sus medidas.',
    stepAnnounce: 'Paso {{n}} de {{total}}: {{step}}',
    stepsDone: '{{done}} de {{total}} completados',
    stepDone: 'Completado',
    stepToDo: 'Pendiente',
    stepPrevious: 'Atrás: {{step}}',
    stepNext: 'Siguiente: {{step}}',
    stepOutdoorsSummary: 'Espacios: {{count}}',
    stepCreativesSummary: '{{done}} de {{total}} listas',
    stepTermsAccepted: 'Aceptados',
    stepTermsPending: 'Aún no aceptados',
    stepPendingHint_outdoors: 'Añada al menos un espacio para continuar.',
    stepPendingHint_creatives: 'Todas las creatividades obligatorias deben estar subidas y aprobadas.',
    stepPendingHint_terms: 'Acepte los términos para desbloquear el pago.',
    goToPayment: 'Ir al pago',
    acceptTermsStepLabel: 'He leído y acepto los Términos y Condiciones de esta campaña.',
    payStepTitle: 'Revisar y pagar',
    payStepMissingTitle: 'Complete estos pasos para pagar:',
    payStepTotal: 'Total de la campaña',
    scheduleTitle: 'Calendario de pagos',
    scheduleTotal: 'Total {{amount}}',
    scheduleFullPayment: 'Pago total',
    scheduleFirstPayment: 'Primer pago · {{month}}',
    scheduleDueAtCheckout: 'Se cobra en el pago',
    scheduleAuthorisedAtCheckout: 'Autorizado en el pago, se cobra cuando los proveedores confirmen',
    scheduleDueOn: 'El {{date}}',
    schedulePaidOn: 'Pagado el {{date}}',
    scheduleProcessing: 'En proceso: las domiciliaciones tardan unos días',
    scheduleFailed: 'Pago fallido',
    scheduleCancelled: 'Cancelado: no se cobrará',
    scheduleSplit: 'Producción {{production}} · Días de campaña {{ads}}',
    scheduleVatIncluded: 'Todos los importes incluyen IVA.',
    paymentsTitle: 'Pagos',
    paymentsPaidSoFar: 'Pagado hasta ahora',
    paymentsRemaining: 'Quedan {{amount}} por pagar',
    paymentsFailedNotice: 'Una domiciliación no se ha completado. Revise su cuenta bancaria o contáctenos para que su campaña no se interrumpa.',
    paymentPlanTitle: '¿Cómo quiere pagar?',
    paymentPlanSubtitle: 'Elija antes del pago. Puede cambiarlo hasta que pague.',
    planTotalTitle: 'Pagar el total',
    planTotalDesc: 'Un único pago por toda la campaña.',
    planMonthlyTitle: 'Pagar mensualmente',
    planMonthlyDesc: 'Pague ahora los costes de producción y el primer mes. Cada mes siguiente se cobra por domiciliación el día 1.',
    paymentPlanError: 'No se pudo actualizar el plan de pago.',
    checkoutAllInstant: 'Todos los espacios son de reserva inmediata: se le cobra en el pago y su campaña queda confirmada al instante.',
    checkoutNeedsConfirmation: '{{count}} de {{total}} espacios necesitan la confirmación de su proveedor. En el pago, su tarjeta solo se autoriza: se le cobra cuando los proveedores confirmen y solo por los espacios aprobados.',
    mandateStepTitle: 'Paso 1 de 2 · Configure su domiciliación',
    mandateStepDesc: 'A continuación, hará su primer pago con tarjeta.',
    confirmingTitle: 'Esperando la confirmación de los proveedores',
    confirmingDesc: 'Su tarjeta se ha autorizado, no cobrado. Solo se le cobrará por los espacios que aprueben sus proveedores.',
    awaitingDecisionTitle: 'Algunos espacios no están disponibles',
    awaitingDecisionDesc: 'Continúe con los espacios aprobados o cancele la campaña y libere su pago.',
    providersAnswerBy: 'Los proveedores responden antes del {{date}}',
    decideBy: 'Decida antes del {{date}}; si no, la campaña se cancela y no se cobra nada.',
    feedbackCount_approved: 'Aprobados: {{count}}',
    feedbackCount_confirming: 'Esperando respuesta: {{count}}',
    feedbackCount_unavailable: 'No disponibles: {{count}}',
    feedbackCount_expired: 'Sin respuesta a tiempo: {{count}}',
    proceedWithApproved: 'Continuar con los espacios aprobados',
    proceedNoneApproved: 'Todavía no se ha aprobado ningún espacio.',
    removeConfirmingHint: 'Aún puede quitar espacios que esperan respuesta.',
    proceedModalTitle: '¿Continuar con los espacios aprobados?',
    proceedOutdoorsLabel: 'Espacios reservados',
    proceedOutdoorsValue: '{{approved}} de {{total}}',
    proceedChargedLabel: 'Se le cobrará',
    proceedTotalMonthlyLabel: 'Total de la campaña',
    proceedModalNote: 'Este importe se cobra ahora en su tarjeta.',
    proceedModalMonthlyNote: 'Su primer pago se cobra ahora y el resto a plazos, por domiciliación.',
    proceedModalDropped: 'Los demás espacios ({{count}}) se quitarán de esta campaña.',
    proceedSuccess: 'Su campaña está confirmada.',
    cancelDecisionTitle: '¿Cancelar esta campaña?',
    cancelDecisionDesc: 'El pago autorizado se libera y no se cobra nada. Todos los espacios quedan libres para otros anunciantes.',
    unavailableTitle: 'Ninguno de los espacios estaba disponible',
    unavailableDesc: 'Sus proveedores no pudieron confirmar estas fechas, así que no se cobró nada. Pruebe otras fechas u otros espacios.',
    feedback_CONFIRMING: 'Esperando proveedor',
    feedback_APPROVED: 'Aprobado',
    feedback_UNAVAILABLE: 'No disponible',
    feedback_EXPIRED: 'Sin respuesta',
    creativeThumbnailAlt: 'Creatividad de la campaña {{name}}',
    title: 'Campañas',
    newCampaign: 'Nueva Campaña',
    newCampaignTooltip: 'Haz clic para crear una nueva campaña',
    mustRegisterAsAdvertiser: 'Debe registrarse como Anunciante para poder crear Campañas',
    noCampaigns: 'Sin campañas todavía',
    noCampaignsDesc: 'Crea tu primera campaña para empezar a anunciar en vallas.',
    browseSpaces: 'Explorar espacios publicitarios',
    status: 'Estado',
    from: 'Desde',
    to: 'Hasta',
    filter: 'Filtrar',
    clearFilter: 'Limpiar filtro',
    outdoorSlots: 'Vallas',
    outdoorsColHeader: 'Vallas',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    paginationRange: 'Campañas {{from}}-{{to}} de {{total}}',
    creatives: 'Creatividades',
    payment: 'Pago',
    deleteTitle: 'Eliminar Campaña',
    deleteConfirm: '¿Estás seguro de que quieres eliminar esta campaña? Esta acción no se puede deshacer.',
    uploadCreative: 'Subir creatividad',
    removeCreative: 'Eliminar',
    deletingCreative: 'Eliminando creativo…',
    creativeRatioMismatch: 'La proporción de la imagen no coincide con el formato {{ratio}} requerido. Por favor, sube una imagen con las proporciones correctas o un PDF.',
    getPaymentDetails: 'Obtener detalles de pago',
    requiredRatios: 'Proporciones de creatividad requeridas',
    iban: 'IBAN',
    reference: 'Referencia de pago',
    viewCampaign: 'Ver',
    loading: 'Cargando campañas…',
    noSlots: 'No hay espacios de valla en esta campaña.',
    noCreatives: 'Aún no hay creatividades subidas.',
    subtitle: 'Gestiona tus campañas de publicidad exterior',
    noFound: 'No se encontraron campañas',
    noFoundDesc: 'Comienza añadiendo vallas a tu carrito para crear tu primera campaña.',
    browseOutdoors: 'Explorar vallas',
    outdoorsCount: '{{count}} valla',
    outdoorsCount_plural: '{{count}} vallas',
    creativesCount: '{{count}} creatividades',
    paymentLabel: 'Pago: {{status}}',
    backToCampaigns: 'Volver a Campañas',
    checklistTitle: 'Lista de comprobación de la campaña',
    checklistOutdoors: 'Elige vallas para tu campaña',
    checklistCreatives: 'Añadir creatividades',
    checklistTerms: 'Aceptar los Términos y Condiciones',
    checklistPay: 'Pagar la campaña',
    acceptTermsPrefix: 'Acepto los',
    acceptTermsLink: 'Términos y Condiciones',
    acceptTermsRequiredHint: 'Debes aceptar los Términos y Condiciones antes de pagar esta campaña.',
    advertiserTermsModalTitle: 'Términos y Condiciones para Anunciantes y Campañas',
    advertiserTermsModalHint: 'Estas son las secciones de nuestros Términos y Condiciones que se aplican específicamente a anunciantes y campañas.',
    viewFullTerms: 'Ver Términos y Condiciones completos',
    outdoorsHeader: 'Vallas ({{count}})',
    noOutdoorsYet: 'Aún no se han añadido vallas.',
    requiredAspectRatios: 'Proporciones de creatividad requeridas',
    recResolution: 'recomendado: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: 'incl. margen de corte',
    dimensionsCalculatorBleedNote: 'Este soporte tiene {{bleed}} cm de margen de corte en cada lado, por lo que las medidas cubren toda el área de impresión de {{w}} × {{h}} m (el área visible es de {{trimW}} × {{trimH}} m).',
    orientationLandscape: 'Horizontal',
    orientationPortrait: 'Vertical',
    dimensionsCalculatorTooltip: 'Calcular posibles dimensiones del creativo',
    dimensionsCalculatorTitle: 'Calculadora de dimensiones para creativo con proporción {{ratio}}',
    dimensionsCalculatorHint: 'Cambia el ancho o el alto (en centímetros) y el otro lado se actualiza automáticamente para mantener esta proporción. Siempre trabajamos a 300 dpi, favoreciendo una escala de 1:10 del tamaño real del soporte exterior.',
    dimensionsCalculatorWidthLabel: 'Ancho (cm)',
    dimensionsCalculatorHeightLabel: 'Alto (cm)',
    dimensionsCalculatorDpiLabel: 'Resolución de impresión',
    dimensionsCalculatorScaleHint: 'Escala: 1:{{scale}} - recomendamos 1:10 o un diseño mayor (número de escala menor).',
    dimensionsCalculatorExportHint: 'Exporta tu archivo a {{w}} × {{h}} px.',
    dimensionsCalculatorMinQualityWidth: 'Demasiado pequeño para buena calidad de impresión - se necesitan al menos {{min}} cm para un diseño en escala 1:{{scale}}.',
    dimensionsCalculatorMinQualityHeight: 'Demasiado pequeño para buena calidad de impresión - se necesitan al menos {{min}} cm para un diseño en escala 1:{{scale}}.',
    processingImage: 'Procesando imagen...',
    noCreativesYet: 'Aún no se han subido creatividades',
    creativesNote: 'Estas son las imágenes que se mostrarán en los soportes publicitarios exteriores durante tu campaña.',
    clickToUpload: 'Haz clic para subir',
    creativeValid: 'Aprobado',
    creativeUnderReview: 'En revisión',
    creativeInvalid: 'No válido',
    deleteCreativeTitle: '¿Eliminar creativo?',
    deleteCreativeBody: 'Este creativo ha sido aprobado o está en revisión. Al eliminarlo se quitará de la campaña y será necesario volver a subirlo.',
    campaignInfo: 'Info de la Campaña',
    details: 'Detalles',
    requestPayment: 'Solicitar Pago',
    paymentDetails: 'Detalles de Pago',
    currency: 'Moneda',
    bankTransferDetails: 'Detalles de transferencia bancaria',
    amount: 'Importe',
    importantRef: '⚠️ Importante - Referencia de Pago',
    refNote: 'Debes incluir esta referencia en la descripción de tu transferencia para que se corresponda automáticamente.',
    deleteCampaign: 'Eliminar Campaña',
    deleteCampaignDesc: 'Esto eliminará permanentemente esta campaña y todos los datos asociados. Esta acción no se puede deshacer.',
    addOutdoor: 'Añadir Exterior',
    outdoorAdded: 'Exterior añadido a la campaña',
    selectOutdoor: 'Selecciona un exterior',
    outdoorDateConflict: 'Este exterior ya está reservado en esta campaña para fechas superpuestas. Por favor elige fechas diferentes.',
    alreadyInCampaign: 'En campaña',
    name: 'Nombre',
    outdoorSubtotal: 'Subtotal',
    bankTransferNoticeTitle: 'Pago de Campaña Requerido',
    bankTransferNotice: 'Su campaña solo se activará y todos los espacios quedarán formalmente reservados tras la confirmación total del pago. Haga clic en "Validar y Pagar" para continuar. Nota: la disponibilidad de los soportes se revalida en el momento del pago - los espacios disponibles al añadirse a la campaña pueden ya no estar garantizados.',
    requestPaymentDisabledHint: 'Los {{count}} creativos requeridos deben estar subidos y validados (estado: Válido) antes de solicitar el pago.',
    outdoorRemoved: 'Espacio eliminado de la campaña.',
    removeOutdoorConfirm: '¿Estás seguro de que deseas eliminar este espacio de la campaña? Esta acción no se puede deshacer.',
    qualityFail: 'Resolución insuficiente - archivo no subido',
    qualityWarn: 'La proporción no coincide - la imagen puede recortarse o tener márgenes',
    qualityAspectMismatch: 'Relación {{actual}} vs {{expected}} (exterior)',
    qualityUploadAnyway: 'Subir de todas formas',
    qualityConfirmHint: 'La imagen puede recortarse o tener márgenes para ajustarse a este formato.',
    qualityDetailFail: 'Este archivo solo tiene nitidez suficiente para {{achievedScale}} en un soporte de {{outdoorW}} × {{outdoorH}} m.',
    qualityTargetFail: 'Diseña tu pieza a {{w}} × {{h}} cm (escala 1:{{scale}}, {{dpi}} dpi) para este formato.',
    recResolutionPx: 'recomendado: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: 'Cambia el ancho o el alto y el otro lado se actualiza automáticamente para mantener esta proporción; el DPI efectivo también se actualiza, para que puedas encontrar dimensiones alternativas que sigan imprimiendo con buena calidad.',
    dimensionsCalculatorWidthLabelPx: 'Ancho (px)',
    dimensionsCalculatorHeightLabelPx: 'Alto (px)',
    dimensionsCalculatorDpiLabelPx: 'DPI efectivo',
    dimensionsCalculatorMinDpiHintPx: 'Se requieren al menos {{dpi}} dpi para este soporte exterior.',
    dimensionsCalculatorMinQualityWidthPx: 'Aún no se alcanza la calidad mínima de ancho (mín. {{min}}px, recomendado: {{rec}}px).',
    dimensionsCalculatorMinQualityHeightPx: 'Aún no se alcanza la calidad mínima de alto (mín. {{min}}px, recomendado: {{rec}}px).',
    qualityWarnLowRes: 'Baja resolución - la imagen puede imprimirse con mala calidad',
    qualityConfirmHintLowRes: 'La imagen puede imprimirse con pérdida de calidad visible.',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px da {{dpi}} DPI a tamaño real.',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px da {{dpi}} DPI a {{outdoorW}} × {{outdoorH}} m, por debajo del mínimo de {{minDpi}} DPI.',
    qualityTargetWarnPx: 'Recomendamos al menos {{recDpi}} DPI para este formato: {{recW}} × {{recH}} px, o {{recScaleLabel}}.',
    qualityTargetFailPx: 'Necesitas al menos {{minW}} × {{minH}} px - trabajando a 1:{{scale}}, eso es un lienzo de {{canvasW}} × {{canvasH}} m a {{designDpi}} DPI.',
    creativeUnitLabel: 'Unidades de tamaño',
    creativeUnitCm: 'Centímetros',
    creativeUnitPx: 'Píxeles',
    creativeUnitHint: 'Elige cómo se muestran y comprueban los tamaños recomendados de las creatividades. Centímetros: diseña a escala 1:10 del soporte, siempre a 300 dpi. Píxeles: resolución mínima según el tamaño del soporte.',
    previewBadge: 'Vista previa',
    previewOnlyHint: 'Solo vista previa - descarga el original para imprimir',
    downloadPrintFile: 'Descargar archivo de impresión',
    downloadPrintFileHint: 'Original a resolución completa',
    printFileExplainer: 'La imagen de arriba es una vista previa ligera. Descarga el archivo original, a resolución completa, para enviarlo a imprenta.',
    previewFailed: 'No pudimos preparar una vista previa de este archivo en tu navegador. Expórtalo como JPG o PNG e inténtalo de nuevo.',
    creativeFileRequirements: 'Archivos aceptados: TIF, TIFF, JPG, JPEG, PNG o PDF. La impresión requiere el modo de color CMYK. Las imágenes en otros modos de color se convierten a CMYK, con una vista previa para que la apruebes antes de subirla. Los archivos PDF ya deben estar en CMYK.',
    creativeFormatNotAllowed: '"{{name}}" no es un tipo de archivo aceptado. Sube un archivo TIF, TIFF, JPG, JPEG, PNG o PDF.',
    creativeNotCmykPdf: '"{{name}}" contiene colores RGB (en el diseño o en una imagen incrustada). Los archivos de impresión deben estar totalmente en CMYK - expórtalo de nuevo con un perfil de color CMYK (p. ej. PDF/X-1a) y súbelo.',
    creativeUnreadable: 'No pudimos leer "{{name}}". Puede estar dañado o guardado de forma inusual - expórtalo de nuevo e inténtalo otra vez.',
    cmykNoticeTitle: '"{{name}}" no está en modo de color CMYK',
    cmykNoticeBody: 'La impresión requiere CMYK. Podemos convertirlo por ti con el perfil estándar para impresión exterior y revisarás una vista previa del antes y el después antes de subir nada.',
    cmykConvert: 'Convertir a CMYK',
    cmykModalTitle: 'Convertir a CMYK para impresión',
    cmykConverting: 'Convirtiendo a CMYK ({{profile}})…',
    cmykBefore: 'Original',
    cmykAfter: 'Vista previa de impresión (CMYK)',
    cmykShiftWarning: 'Algunos colores vivos se verán notablemente distintos en la impresión (alrededor del {{percent}}% de la imagen). Si los colores exactos son importantes, ajusta el diseño en tu software antes de subirlo.',
    cmykProfileNote: 'Convertido con el perfil {{profile}}, el estándar para impresión exterior. Las pantallas no pueden mostrar CMYK con exactitud, por lo que la vista previa simula el resultado impreso.',
    cmykAccept: 'Aceptar la versión CMYK convertida',
    cmykErrorUnavailable: 'La conversión a CMYK no está disponible temporalmente. Convierte el archivo a CMYK en tu software de diseño y vuelve a subirlo.',
    cmykErrorTooLarge: 'Esta imagen es demasiado grande para convertirla en el navegador. Conviértela a CMYK en tu software de diseño y vuelve a subirla.',
    cmykErrorFailed: 'No pudimos convertir este archivo. Conviértelo a CMYK en tu software de diseño y vuelve a subirlo.',
    pay: 'Validar y Pagar',
    commission: 'Comisión de plataforma ({{rate}}%)',
    vatLabel: 'IVA',
    vatWithRate: 'IVA ({{rate}}%)',
    vatDetailsTitle: 'Detalles del IVA',
    vatDetailsBody: 'El IVA se calcula según el tratamiento fiscal aplicable a cada componente de la campaña. Algunos importes pueden incluir IVA, estar sujetos a un tipo de IVA distinto o quedar fuera de la base imponible del IVA.',
    totalWithoutVat: 'Total (sin IVA)',
    grandTotal: 'Total',
    dailyRateRoundingNote: 'Las tarifas diarias se redondean al céntimo más cercano.',
    platformFeeNote: '* Las tarifas diarias de los espacios ya incluyen una comisión de plataforma del 5%.',
    confirmPayment: 'Confirmar Pago',
    paymentSuccess: '¡Pago realizado con éxito! Su campaña se activará en breve.',
    checkingPayment: 'Verificando su pago…',
    paymentConfirmed: '¡Pago Confirmado!',
    paymentConfirmedDesc: 'Su pago ha sido confirmado. Su campaña se activará en breve.',
    paymentPending: 'Pago No Confirmado',
    paymentPendingDesc: 'Su pago no pudo confirmarse en este momento. Inténtelo de nuevo o contacte con el soporte.',
    backToCampaign: 'Volver a la Campaña',
    expandPricing: 'Mostrar detalles de precios',
    collapsePricing: 'Ocultar detalles de precios',
    availabilityUpdated: 'Uno o más espacios fueron eliminados de su campaña - habían sido reservados por otra campaña para fechas solapadas, o su período de antelación mínima ya había expirado. Por favor, revise la selección actualizada a continuación.',
    availabilityDialogTitle: 'Confirmar disponibilidad y proceder al pago',
    availabilityDialogBody: 'Antes de continuar, verificaremos que todos los exteriores seleccionados sigan disponibles. Algunos podrían haber sido reservados por otras campañas. Indique cómo desea gestionar los conflictos.',
    availabilityRemoveYes: 'Sí - eliminar automáticamente los exteriores no disponibles',
    availabilityRemoveYesDesc: 'Los exteriores que ya no estén disponibles serán eliminados de esta campaña. Puede revisar la selección actualizada antes de realizar el pago.',
    availabilityRemoveNo: 'No - marcar conflictos y revisarlos manualmente',
    availabilityRemoveNoDesc: 'Los exteriores en conflicto serán destacados para que pueda ajustar sus fechas o eliminarlos manualmente antes de continuar.',
    availabilityDialogConfirm: 'Proceder al pago',
    outdoorFlaggedTitle: 'Fechas ya no disponibles',
    outdoorFlaggedDesc: 'Este exterior ha sido reservado por otra campaña para fechas que se solapan. Edite las fechas o elimínelo para continuar.',
    outdatedOutdoorsTitle: 'La campaña no puede continuar - se han detectado emplazamientos desactualizados',
    outdatedOutdoorsDesc: 'Uno o más exteriores tienen una fecha de inicio que ya ha pasado. El pago no ha sido procesado. Revise los emplazamientos marcados y actualice sus fechas antes de reintentar.',
    outdoorOutdatedTitle: 'Fecha de inicio en el pasado',
    outdoorOutdatedDesc: 'La fecha de inicio programada para este emplazamiento ya ha pasado. Actualícela a una fecha futura para continuar.',
    pastStartDatesToast: 'Las fechas de la campaña no pueden estar en el pasado.',
    cancelCampaign: 'Cancelar Campaña',
    cancelCampaignConfirm: 'Esta acción cancelará permanentemente su campaña. ¿Está seguro?',
    cancelCampaignYes: 'Sí, cancelar',
    cancelCampaignAbort: 'Mantener campaña',
    cancelledSuccess: 'La campaña ha sido cancelada.',
    cancellationPolicyPending: 'Cancelación gratuita - no se aplican cargos mientras su campaña esté en estado Pendiente.',
    cancellationPolicyReady: 'Cancelación gratuita si todos los outdoors se cancelan con más días de antelación que el período de preaviso mínimo de su Proveedor de Espacios. Se aplica una comisión de cancelación si uno o más outdoors se encuentran dentro de su período de preaviso mínimo (más IVA para empresas portuguesas). Los costes de producción (impresión, instalación, etc.) no son reembolsables para cualquier outdoor dentro del período de preaviso mínimo.',
    cancellationPolicyRunning: 'Tenga en cuenta: la cancelación de una campaña que ya está en curso conlleva la pérdida del 100% del valor de la campaña. No se emitirá ningún reembolso.',
    ppInvoices: 'Facturas de los Proveedores de Espacio',
    outdoorAdj0: 'increíbles',
    outdoorAdj1: 'geniales',
    outdoorAdj2: 'magníficos',
    outdoorAdj3: 'fabulosos',
    outdoorAdj4: 'excepcionales',
    outdoorsCollapsedSummary: '¡Aquí tenemos {{count}} outdoors {{adj}}!',
    messages: 'Mensajes',
    noMessages: 'Ningún proveedor de espacios ha enviado mensajes sobre esta campaña todavía. Cuando lo hagan, sus conversaciones aparecerán aquí.',
    noMessagesYet: 'Aún no hay mensajes en esta conversación.',
    typeMessage: 'Escribe un mensaje…',
    instructions: 'Instrucciones para los Proveedores de Espacios',
    instructionsPlaceholder: 'ej. Por favor, muestre esta campaña solo de 8h a 22h.',
    instructionsEmpty: 'Aún no se han añadido instrucciones. Haga clic en Editar para añadir indicaciones.',
    instructionsSaved: 'Instrucciones guardadas.',
    proofOfDisplay: 'Prueba de Exhibición',
    proofPending: 'Prueba en breve',
    proofPendingDesc: 'Tu proveedor de espacio subirá la prueba de exhibición en breve.',
    proofAlt: 'Prueba de exhibición – {{name}}',
    additionalFiles: 'Archivos adicionales',
    additionalFilesSubtitle: 'Materiales de apoyo para esta campaña - no obligatorios.',
    additionalFilesSubtitlePP: 'Materiales de apoyo compartidos por el anunciante.',
    noAdditionalFiles: 'Aún no se han subido archivos adicionales.',
    uploadFile: 'Subir archivo',
    fileUploaded: 'Archivo subido correctamente.',
    fileDeleted: 'Archivo eliminado.',
    deleteFile: 'Eliminar archivo',
    addOutdoors: 'Añadir exteriores',
    creativesLockedTitle: 'Aún no hay exteriores añadidos',
    creativesLockedDesc: 'Los creativos deben coincidir con la resolución requerida de cada exterior. Añade al menos uno para habilitar las subidas.',
    editDates: 'Editar fechas',
    updateDates: 'Actualizar fechas',
    datesUpdated: 'Fechas actualizadas correctamente',
  },
  dashboard: {
    title: 'Panel',
    earnings: 'Ingresos',
    spendings: 'Gastos',
    last30: 'Últimos 30 días',
    last90: 'Últimos 90 días',
    thisYear: 'Este año',
    accessRequests: 'Solicitudes de Acceso',
    noRequests: 'Sin solicitudes pendientes',
    approve: 'Aprobar',
    reject: 'Rechazar',
    teamInvite: 'Invitar Miembro del Equipo',
    inviteEmail: 'Dirección de correo',
    sendInvite: 'Enviar Invitación',
    totalEarned: 'Total ganado',
    totalSpent: 'Total gastado',
    activeOutdoors: 'Vallas activas',
    activeCampaigns: 'Campañas activas',
    overview: 'Resumen',
    howPaidTitle: 'Cómo recibes el pago',
    howPaidDesc: 'Una vez que una campaña esté activa, sube pruebas fotográficas para cada valla. Cuando todas las pruebas sean verificadas, tu pago se libera automáticamente. Tu pago se calcula en base a tu tarifa diaria multiplicada por el número de días activos de la campaña, menos una comisión de servicio de plataforma del 5% aplicada por reserva.',
    ppOverview: 'Resumen del Proveedor de Espacios',
    advertiserOverview: 'Resumen del Anunciante',
    findOutdoors: 'Buscar Vallas',
    addOutdoor: 'Añadir Valla',
    viewCampaigns: 'Ver Campañas',
    manageOutdoors: 'Gestionar Vallas',
    companyDetails: 'Detalles de la Empresa',
    userDetails: 'Datos del usuario',
    pendingRequests: 'Solicitudes de Acceso Pendientes ({{count}})',
    inviteDesc: 'Recibirán un email con un enlace para unirse a tu empresa en Scapow.',
    invitePlaceholder: 'colega@empresa.com',
    invoicesTitle: 'Facturas',
    downloadInvoice: 'Descargar',
    invoiceIssued: 'Emitida',
    invoicePaid: 'Pagada',
    invoiceUnknownCampaign: 'Campaña desconocida',
    invoicesSubtitle: 'Tu historial de pagos y documentos de factura descargables.',
    invoicesEmpty: '¡Esperamos poder llenar esta sección muy pronto!',
  },
  invoices: {
    title: 'Facturas',
    subtitleAdvertiser: 'Facturas de Scapow y de los propietarios de espacios en todas tus campañas.',
    subtitlePP: 'Tu historial de pagos y facturas descargables.',
    issued: 'Emitida',
    download: 'Descargar',
    empty: 'Aún no hay facturas. Aparecerán aquí una vez que tus campañas sean procesadas.',
    unknownCampaign: 'Campaña desconocida',
    ppInvoices: 'Facturas de propietarios ({{count}})',
    unknownProvider: 'Proveedor desconocido',
    notAvailable: 'No disponible',
    typeInvoice: 'Factura',
    typeCreditNote: 'Nota de crédito',
  },
  payments: {
    title: 'Pagos',
    subtitle: 'Tu historial de pagos por las campañas realizadas en tus espacios.',
    empty: 'Aún no hay pagos. Aparecerán aquí una vez que se abonen tus campañas.',
    unknownCampaign: 'Campaña desconocida',
    columnId: 'ID de pago',
    columnCampaign: 'Campaña',
    columnValue: 'Valor',
    columnPaidAt: 'Pagado el',
    columnStatus: 'Estado',
    statusPaid: 'Pagado',
    statusTransferRequested: 'Transferencia solicitada',
  },
  userDetails: {
    receiveEmails: 'Recibir correos',
    receiveEmailsOnDesc: 'Los correos de la plataforma se envían a {{email}}.',
    receiveEmailsOffDesc: 'No recibirá correos de la plataforma. Actívelo para volver a recibirlos.',
    emailsTurnedOn: 'Recibirá correos de la plataforma.',
    emailsTurnedOff: 'Ya no recibirá correos de la plataforma.',
    emailsUpdateError: 'No se pudo actualizar su preferencia de correo.',
    title: 'Datos de la cuenta',
    subtitle: 'Gestiona la información de tu cuenta personal.',
    name: 'Nombre',
    editName: 'Haz clic para editar',
    email: 'Correo electrónico',
    memberSince: 'Miembro desde (UTC)',
    accountStatus: 'Estado de la cuenta',
    statusVerified: 'Verificado',
    statusPending: 'Verificación pendiente',
    nameUpdated: 'Nombre actualizado correctamente.',
    nameRequired: 'Introduce un nombre válido (mínimo 2 caracteres).',
    password: 'Contraseña',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    passwordUpdated: 'Contraseña actualizada correctamente.',
    passwordFieldsRequired: 'Por favor, completa todos los campos de contraseña.',
    passwordTooShort: 'La nueva contraseña debe tener al menos 8 caracteres.',
    passwordSameAsCurrent: 'La nueva contraseña debe ser diferente de la contraseña actual.',
    passwordMismatch: 'La nueva contraseña y la confirmación no coinciden.',
  },
  admin: {
    tabUnpaidInstallments: 'Cuotas impagadas',
    unpaidInstallmentsIntro: 'Cuotas aún sin pagar 6 días después de su vencimiento, de la más antigua a la más reciente.',
    noUnpaidInstallments: 'No hay cuotas impagadas.',
    installmentOf: 'Cuota {{number}} de {{total}}',
    installmentNumber: 'Cuota {{number}}',
    installmentDue: 'Vence el {{date}}',
    installmentOverdueDays_one: '{{count}} día de retraso',
    installmentOverdueDays_other: '{{count}} días de retraso',
    proofOfCompany: 'Justificante de empresa',
    openProofOfCompany: 'Abrir {{name}} en una pestaña nueva',
    noProofOfCompany: 'No se ha subido justificante de empresa',
    proofLocationLoading: 'Buscando la dirección…',
    proofLocationViewMap: 'Ver en el mapa',
    title: 'Panel de Administración',
    verifications: 'Verificaciones',
    advertisers: 'Anunciantes',
    providers: 'Proveedores',
    payments: 'Pagos',
    noVerifications: 'Sin verificaciones pendientes',
    noPayments: 'Sin pagos pendientes',
    markAsDone: 'Marcar como completado',
    business: 'Empresa',
    type: 'Tipo',
    status: 'Estado',
    actions: 'Acciones',
    approve: 'Aprobar',
    reject: 'Rechazar',
    subtitle: 'Gestión y moderación de la plataforma',
    proofVerification: 'Verificaciones Manuales',
    accessRequestsTab: 'Solicitudes de Acceso',
    noAccessRequests: 'Sin solicitudes de acceso pendientes.',
    noAdvertisers: 'No se encontraron anunciantes.',
    noProviders: 'No se encontraron proveedores.',
    noPaymentsStatus: 'Sin pagos con este estado.',
    campaignOutdoor: 'Valla de campaña: {{id}}',
    campaignFrom: 'Campaña del {{date}}',
    adCreative: 'Creatividad publicitaria',
    proofPhotos: 'Fotos de prueba ({{count}}) - haz clic para abrir en tamaño completo',
    period: 'Período',
    outdoorsLabel: 'vallas',
    campaignsLabel: 'campañas',
    spentLabel: 'gastado',
    earnedLabel: 'ganado',
    markAsPaid: 'Marcar como Pagado',
    tabAds: 'Anuncios',
    tabBusinessProofs: 'Pruebas de Empresa',
    tabProofOfAds: 'Pruebas de Anuncios',
    approved: 'Aprobado',
    rejected: 'Rechazado',
    noAds: 'Sin verificaciones de anuncios pendientes.',
    noBusinessProofs: 'Sin pruebas de empresa pendientes.',
    noProofOfAds: 'Sin pruebas de anuncios pendientes.',
    refundsTab: 'Reembolsos y Deudas',
    refundsSearchPlaceholder: 'Buscar por nombre de campaña o anunciante…',
    refundsNoCampaigns: 'No se encontraron campañas.',
    refundsSelectOutdoors: 'Seleccionar outdoors para reembolso',
    refundsSelectAll: 'Seleccionar todos',
    refundsDeselectAll: 'Deseleccionar todos',
    refundsNoEligible: 'No se encontraron outdoors elegibles para esta campaña.',
    refundsEligibleNote: 'Solo los outdoors no rechazados son elegibles para reembolso.',
    refundsSubmit: 'Procesar Reembolso',
    refundsSuccess: 'Reembolso procesado correctamente.',
    refundsSubTabRefunds: 'Reembolsos a Anunciantes',
    refundsSubTabDebts: 'Deudas de Proveedores',
    refundTypeTotal: 'Total',
    refundTypePartial: 'Parcial',
    refundDaysLabel: 'Días a reembolsar',
    refundDaysHint: 'Máx. {{max}} días',
    debtNoDebts: 'No hay deudas pendientes de proveedores.',
    debtSettle: 'Liquidar',
    debtSettleAmount: 'Importe de liquidación',
    debtSettleDoc: 'Documento de liquidación',
    debtSettleDocHint: 'Suba el documento de liquidación firmado (PDF, imagen, etc.)',
    debtSettleConfirm: 'Subir y liquidar',
    debtSettleSuccess: 'Deuda liquidada y documento subido correctamente.',
    debtStatusOutstanding: 'Pendiente',
    debtStatusSettled: 'Liquidado',
    debtCampaign: 'Campaña',
    campaignsTab: 'Campañas',
    noCampaigns: 'No se encontraron campañas.',
    accessRequestFor: 'Solicitando acceso a: {{entity}}',
    tabByStatus: 'Por Estado',
    tabTransferRequested: 'Transferencia Solicitada',
    checkPayment: 'Verificar',
    lastCheckedAt: 'Última verificación',
    neverChecked: 'Nunca verificado',
    noTransferRequested: 'No se encontraron pagos con transferencia solicitada.',
    checkSuccess: 'Verificación de pago iniciada.',
    revenueTitle: 'Ingresos',
    revenueSubtitle: 'Comisión de la plataforma e IVA por período de facturación',
    revenueGross: 'Ingresos brutos',
    revenueCommission: 'Comisión',
    revenueVat: 'IVA',
    revenueStripeFees: 'Comisiones de Stripe',
    revenueNet: 'Ingresos netos',
    revenueEmpty: 'No hay ingresos registrados para este período.',
    revenueMonth: 'Mes',
    revenueYear: 'Año',
    revenueDailyTitle: 'Desglose Diario',
    revenueNoDaily: 'Sin datos diarios para este período.',
    searchByName: 'Buscar por nombre…',
    importOutdoorsFromFile: 'Importar publicidad exterior desde archivo',
    chooseFile: 'Elegir archivo…',
    csvSend: 'Enviar',
    importOutdoorsSuccess: 'Archivo de publicidad exterior enviado correctamente.',
    remainingFreeCommissions: 'Comisiones gratuitas restantes: {{count}}',
    setFreeCommissions: 'Establecer nuevas comisiones gratuitas restantes',
    freeCommissionsUpdated: 'Comisiones gratuitas restantes actualizadas.',
    freeCommissionsUpdateFailed: 'No se pudieron actualizar las comisiones gratuitas restantes.',
    verified: 'Verificado',
  },
  ppCampaigns: {
    searchAllStatuses: 'Se muestran campañas en todos los estados. Borre la búsqueda para filtrar por estado.',
    typeAll: 'Todas',
    typeScapow: 'Scapow',
    typeOffline: 'Offline',
    typeFilterLabel: 'Tipo de campaña',
    noOfflineResults: 'Aún no hay campañas offline. Añada espacios a una desde su página de Espacios.',
    goToOutdoors: 'Ir a Espacios',
    offlineBadge: 'Offline',
    moreOutdoors: '+{{count}} más',
    offlineNotes: 'Notas',
    payoutCommission: 'Comisión de la plataforma',
    payoutCommissionVat: 'IVA sobre la comisión de la plataforma',
    payoutTransferred: 'Transferido',
    payoutValueWithoutVat: 'Valor publicitario (sin IVA)',
    payoutVat: 'IVA',
    payoutProduction: 'Costes de producción (IVA incl.)',
    payoutsTitle: 'Cobros',
    payoutsCount: 'Cobros: {{count}}',
    payoutsReceived: 'Recibido hasta ahora',
    payoutFull: 'Cobro total',
    payoutFirst: 'Primer cobro · {{month}}',
    payoutAfterProof: 'Previsto desde el {{date}}, tras aprobarse la prueba de exhibición',
    payoutExpectedOn: 'Previsto el {{date}}',
    payoutReceivedOn: 'Recibido el {{date}}',
    payoutProcessing: 'Transferencia en curso',
    payoutOnHold: 'En espera: la domiciliación del anunciante ha fallado',
    payoutsOnHoldNotice: 'Un cobro está en espera porque la domiciliación del anunciante ha fallado. Se liberará en cuanto ese pago se complete.',
    payoutsNetNote: 'Importes netos de la comisión de Scapow y su IVA, antes de cualquier deuda pendiente.',
    colProduction: 'Producción',
    title: 'Campañas',
    subtitle: 'Supervisa y gestiona las campañas que incluyen tus espacios outdoor.',
    tabPending: 'Pendientes',
    tabReady: 'Listas',
    tabRunning: 'En Curso',
    tabCompleted: 'Completadas',
    noResults: 'No se encontraron campañas para este estado.',
    outdoorSlots: '{{count}} espacio outdoor',
    outdoorSlots_plural: '{{count}} espacios outdoor',
    instructions: 'Instrucciones del anunciante',
    backToCampaigns: 'Volver a las Campañas',
    yourSlots: 'Tus Espacios Outdoor',
    noSlots: 'No se encontraron espacios outdoor de tus propiedades en esta campaña.',
    advertiserInstructions: 'Instrucciones del Anunciante',
    messagesWithAdvertiser: 'Mensajes con el Anunciante',
    noConversation: 'Aún no hay mensajes. Inicia una conversación con el anunciante escribiendo abajo.',
    myInvoice: 'Mi Factura al Anunciante',
    uploadInvoice: 'Subir Factura',
    replaceInvoice: 'Reemplazar Factura',
    uploadInvoiceSuccess: 'Factura subida correctamente.',
    invoiceUploaded: 'Ver factura',
    noInvoiceYet: 'Aún no se ha subido ninguna factura.',
    creativesAndOutdoors: 'Creatividades y sus espacios',
    noCreativeForRatio: 'Aún no se ha subido ninguna creatividad para este formato.',
    yourOutdoorsForFormat: 'Sus espacios para este formato',
    viewOutdoor: 'Ver espacio',
    goToCampaign: 'Ir a la página de campaña',
    yourEarnings: 'Tus ingresos',
    readyPaymentTitle: 'Verificación de pantalla requerida',
    readyPaymentNoteReady: 'Tus ingresos están asegurados a la espera del lanzamiento de la campaña. Una vez que esté activa, sube el comprobante de instalación de cada espacio exterior para iniciar el pago.',
    readyPaymentNote: 'Para liberar tus ingresos, sube el comprobante de instalación de cada espacio exterior en el paso Verificar Pantallas.',
    readyPaymentCta: 'Ir a Verificar Pantallas',
    paymentPaidTitle: 'Pago recibido',
    paymentPaidDesc: 'Tus ganancias de esta campaña ya han sido abonadas.',
    viewBreakdown: 'ver desglose',
    earningsBreakdown: 'Desglose de ingresos',
    colDays: 'Días',
    colNetDailyValue: 'Valor Diario + IVA',
    colEarnings: 'Ingresos',
  },
  upcomingCampaigns: {
    title: 'Próximas Campañas',
    subtitle: 'Campañas listas para ejecutarse que incluyen tus espacios publicitarios.',
    noResults: 'No se encontraron próximas campañas.',
  },
  getPaid: {
    title: 'Cobrar',
    subtitle: 'Sigue los pasos a continuación para verificar tus instalaciones y recibir el pago.',
    step1: { label: 'Próximas Campañas', desc: 'Obtén los Creativos para configurar las Vallas' },
    step2: { label: 'Verificar Instalaciones', desc: 'Sube prueba del anuncio para cobrar' },
    step3: { label: 'Facturas Pagadas', desc: 'Tu historial de pagos' },
    paidOn: 'Pagado el',
    downloadInvoice: 'Factura',
    noPayments: 'Sin pagos todavía',
    noPaymentsDesc: 'Completa el paso de verificación para desbloquear el pago.',
    upcomingEmpty: 'No hay próximas campañas por el momento. Vuelve más tarde.',
    goToVerify: 'Ir a Verificar Instalaciones',
    goToPaid: 'Ver Pagos',
    goToUpcoming: 'Ver Próximas Campañas',
  },
  cart: {
    title: 'Tu Carrito',
    empty: 'Tu carrito está vacío',
    emptyDesc:
      'Busca espacios publicitarios y añádelos al carrito para crear una campaña.',
    browseOutdoors: 'Explorar Vallas',
    campaignDetails: 'Detalles de la Campaña',
    campaignName: 'Nombre de la campaña',
    description: 'Descripción (opcional)',
    subtotal: 'Subtotal',
    total: 'Total',
    remove: 'Eliminar',
    placeOrder: 'Crear Campaña',
    creating: 'Creando…',
    estimatedCost: 'Coste estimado',
    signInTitle: 'Inicia sesión para continuar',
    signInDesc: 'Crea una cuenta o inicia sesión para crear tu campaña.',
    buildCampaign: 'Crear Campaña',
    estimatedTotal: 'Total estimado',
    campaignNamePlaceholder: 'Campaña Verano 2026',
    detailsPlaceholder: 'Alguna nota...',
    campaignLabel: 'Campaña {{n}}',
    selectCampaign: 'Añadir a campaña:',
    signInToCheckout: 'Inicia sesión para crear esta campaña',
    advertiserRequired: 'Necesitas una cuenta de Anunciante para crear campañas',
    instructions: 'Instrucciones para Proveedores de Espacios (opcional)',
    instructionsPlaceholder: 'Aquí deben ir las instrucciones especiales para los Proveedores de Espacios...',
    instructionsHint: 'Puede actualizar este campo después de crear la campaña.',
  },
  invitations: {
    title: 'Invitaciones de Usuarios',
    subtitle: 'Gestionar las invitaciones de miembros del equipo para tu empresa',
    pendingTitle: 'Invitaciones Pendientes',
    noPending: 'Sin invitaciones pendientes',
    noPendingDesc: 'Invita a un miembro del equipo arriba para comenzar.',
    sentAt: 'Enviado',
    cancel: 'Cancelar',
    inviteSuccess: 'Invitación enviada con éxito.',
    inviteError: 'Error al enviar la invitación.',
    cancelSuccess: 'Invitación cancelada.',
    formTitle: 'Invitar Miembro del Equipo',
    formDesc: 'Recibirán un email con un enlace para unirse a tu empresa en Scapow.',
    formPlaceholder: 'colega@empresa.com',
    formSend: 'Enviar Invitación',
  },
  terms: {
    back: 'Volver',
    title: 'Términos y Condiciones',
    effectiveDate: 'Fecha de vigencia: 19 de junio de 2026 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'Al registrar una cuenta, acceder o utilizar la Plataforma, acepta quedar legalmente vinculado por estos Términos. Si no está de acuerdo, no debe utilizar la Plataforma.',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · Vigencia: 19 de junio de 2026',
    s1: 'Introducción',
    s1_p1: 'Estos Términos y Condiciones ("Términos") rigen el acceso y uso de la plataforma SCAPOW ("Plataforma"), operada por Codify, Unipessoal Lda ("Empresa", "nosotros", "nuestro", "nos").',
    s1_p2: 'La Plataforma funciona como un mercado digital que conecta:',
    s1_i1Bold: 'Anunciantes',
    s1_i1Rest: ', que buscan adquirir espacios publicitarios para campañas de marketing; y',
    s1_i2Bold: 'Proveedores de Espacios',
    s1_i2Rest: ', que poseen, operan o controlan espacios publicitarios físicos, incluyendo pero no limitado a vallas publicitarias, señales exteriores, pantallas digitales y otras instalaciones de medios.',
    s2: 'Elegibilidad',
    s2_p1: 'Los usuarios deben:',
    s2_i1: 'Tener al menos 18 años;',
    s2_i2: 'Tener capacidad legal para celebrar acuerdos vinculantes;',
    s2_i3: 'Proporcionar información precisa y completa durante el registro;',
    s2_i4: 'Cumplir con todas las leyes y regulaciones aplicables.',
    s2_p2: 'Los usuarios empresariales declaran que están autorizados a vincular a su empresa u organización.',
    s3: 'Roles de Usuario',
    s3_1: '3.1 Anunciantes',
    s3_1_p1: 'Los Anunciantes pueden:',
    s3_1_i1: 'Buscar, seleccionar y adquirir espacios publicitarios;',
    s3_1_i2: 'Cargar materiales publicitarios;',
    s3_1_i3: 'Lanzar y gestionar campañas.',
    s3_1_p2: 'Los Anunciantes son los únicos responsables de:',
    s3_1_i4: 'La legalidad de su contenido publicitario;',
    s3_1_i5: 'La titularidad o autorización de toda la propiedad intelectual utilizada;',
    s3_1_i6: 'El cumplimiento de las leyes publicitarias.',
    s3_2: '3.2 Proveedores de Espacios',
    s3_2_p1: 'Los Proveedores de Espacios pueden:',
    s3_2_i1: 'Listar espacios publicitarios disponibles;',
    s3_2_i2: 'Establecer precios, disponibilidad de campañas y requisitos operativos;',
    s3_2_i3: 'Aceptar colocaciones de campañas.',
    s3_2_p2: 'Los Proveedores de Espacios declaran y garantizan que:',
    s3_2_i4: 'Son propietarios o controlan legalmente el espacio publicitario;',
    s3_2_i5: 'Cuentan con todos los permisos, licencias y derechos necesarios para uso publicitario comercial;',
    s3_2_i6: 'Pueden cumplir las campañas reservadas dentro de los plazos acordados.',
    s3_3: '3.3 Declaración Legal para el Listado de Espacios Publicitarios',
    s3_3_p1: 'Al listar un espacio publicitario exterior en la Plataforma, cada Proveedor de Espacios debe confirmar expresamente, en el momento de la presentación, que:',
    s3_3_i1: 'Ostenta derechos legales sobre el espacio publicitario presentado;',
    s3_3_i2: 'Está autorizado para ofrecerlo para uso comercial;',
    s3_3_i3: 'El listado cumple con todas las leyes, permisos, licencias, regulaciones de zonificación y requisitos de las autoridades locales aplicables.',
    s3_3_p2: 'Esta declaración es condición del listado. Las presentaciones sin esta confirmación no serán aceptadas. La Plataforma se reserva el derecho de eliminar cualquier listado donde la declaración resulte falsa o engañosa, y de suspender o cancelar la cuenta de cualquier Proveedor de Espacios que proporcione información inexacta.',
    s4: 'Rol de la Plataforma',
    s4_p1: 'La Plataforma actúa únicamente como intermediaria y facilitadora. La Empresa:',
    s4_i1: 'No es propietaria de espacios publicitarios;',
    s4_i2: 'No actúa como anunciante ni proveedor de espacios;',
    s4_i3: 'No garantiza el rendimiento de campañas, impresiones ni resultados comerciales;',
    s4_i4: 'No es responsable de la instalación o retirada física de anuncios.',
    s4_p2: 'Cada transacción establece una relación contractual directa entre el Anunciante y el Proveedor de Espacios.',
    s5: 'Reservas de Campaña',
    s5_p1: 'Una reserva de campaña se vuelve vinculante una vez que:',
    s5_i1: 'El Anunciante ha completado el pago - abonando el total o, en una campaña pagada a plazos, autorizando el primer pago y la domiciliación de las cuotas siguientes;',
    s5_i2: 'Cada espacio publicitario está confirmado - de inmediato en los espacios de reserva inmediata, o por su Proveedor de Espacios dentro del plazo de confirmación;',
    s5_i3: 'Se programe la fecha de inicio de la campaña.',
    s5_p2: 'Todas las reservas están sujetas al período mínimo de aviso operativo especificado por el Proveedor de Espacios. El período mínimo de aviso determina el momento más tardío en que un Anunciante puede presentar y pagar una campaña. El incumplimiento puede resultar en rechazo o reprogramación.',
    s6: 'Condiciones de Pago',
    s6_1: '6.1 Pagos de los Anunciantes',
    s6_1_p1: 'Los Anunciantes pagan según el plan de pago elegido al finalizar la compra:',
    s6_1_i1: 'Pago total - el importe total de la campaña se cobra al finalizar la compra;',
    s6_1_i2: 'Mensual o cada tres meses - los costes de producción y el primer período de facturación se cobran al finalizar la compra, y cada período de facturación siguiente se cobra por domiciliación el primer día. Estos planes solo están disponibles cuando la campaña se extiende más allá de su primer período de facturación.',
    s6_1_p2: 'La compra debe completarse antes de la fecha de inicio de la campaña y antes de que venza el período de preaviso mínimo del Proveedor de Espacios. Cuando los espacios publicitarios requieran confirmación, el pago solo se autoriza al finalizar la compra y se cobra una vez confirmados, y únicamente por los espacios confirmados. El retraso en el pago de cualquier cuota se rige por la sección 6.4. Si la compra no se completa a tiempo:',
    s6_1_i3: 'La reserva puede cancelarse automáticamente;',
    s6_1_i4: 'El Proveedor de Espacios no tiene obligación de reservar el espacio publicitario.',
    s6_2: '6.2 Tarifas de la Plataforma',
    s6_2_p1: 'La Plataforma puede cobrar tarifas de servicio, comisiones o cargos por transacción. Dichas tarifas se informarán antes de la compra. Las tarifas de la Plataforma no son reembolsables salvo que la ley lo exija.',
    s6_3: '6.3 Pagos a los Proveedores de Espacios',
    s6_3_p1: 'Los Proveedores de Espacios son elegibles para el pago únicamente después de que:',
    s6_3_i1: 'Los materiales publicitarios hayan sido completamente instalados;',
    s6_3_i2: 'La prueba de instalación haya sido cargada en la Plataforma;',
    s6_3_i3: 'Dicha prueba sea aprobada o no impugnada dentro del período de revisión aplicable.',
    s6_3_p2: 'La prueba debe incluir evidencia fotográfica clara que muestre la campaña correctamente exhibida. La Plataforma se reserva el derecho de verificar la autenticidad. Los pagos pueden retrasarse, retenerse o revertirse en casos de fraude, disputa o incumplimiento.',
    s6_4: '6.4 Obligaciones de Pago y Retraso en el Pago',
    s6_4_p1: 'Cada reserva confirmada constituye una obligación de pago vinculante del Anunciante. El Anunciante deberá abonar, íntegramente y a su vencimiento, todos los importes correspondientes a las campañas y espacios publicitarios que haya reservado, incluida cada cuota de una campaña pagada a plazos (mensual o trimestralmente).',
    s6_4_i1: 'Todo importe no abonado en su fecha de vencimiento - incluida una domiciliación rechazada, devuelta o revertida - se considerará vencido desde dicha fecha. La Plataforma lo notificará al Anunciante y podrá intentar de nuevo el cobro.',
    s6_4_i2: 'Cuando cualquier importe relativo a una campaña permanezca impagado durante más de dos (2) meses desde su vencimiento, el Proveedor de Espacios podrá, sin responsabilidad alguna frente al Anunciante, retirar las creatividades del Anunciante de los espacios publicitarios afectados y ponerlos a disposición de otros anunciantes.',
    s6_4_i3: 'Dicha retirada no eximirá al Anunciante de sus obligaciones: todos los importes ya vencidos, junto con las comisiones aplicables conforme a la sección 9.3, seguirán siendo exigibles en su totalidad.',
    s6_4_i4: 'La Plataforma y/o el Proveedor de Espacios podrán emprender acciones legales para recuperar los importes pendientes, junto con los intereses de demora al tipo legal aplicable y los costes razonables de cobro y judiciales, en la medida permitida por la legislación aplicable.',
    s6_4_i5: 'La Plataforma podrá asimismo suspender la cuenta del Anunciante y rechazar nuevas reservas hasta que se hayan saldado todos los importes vencidos, conforme a la sección 15.',
    s6_4_p2: 'La retirada de creatividades en virtud de esta sección no constituirá incumplimiento del Proveedor de Espacios conforme a las secciones 9.4 y 9.5 y no dará lugar a reembolso alguno.',
    s7: 'Materiales de Campaña',
    s7_p1: 'Los Anunciantes deben presentar los materiales de campaña dentro del plazo requerido. Los materiales deben:',
    s7_i1: 'Cumplir las especificaciones técnicas;',
    s7_i2: 'Ser imprimibles y utilizables;',
    s7_i3: 'Cumplir con las leyes aplicables;',
    s7_i4: 'No contener contenido ilegal, difamatorio, ofensivo o infractor.',
    s7_p2: 'Los Proveedores de Espacios pueden rechazar materiales no conformes. La Plataforma puede eliminar contenido a su exclusivo criterio.',
    s8: 'Prueba de Instalación',
    s8_p1: 'Los Proveedores de Espacios deben cargar la prueba de instalación de forma inmediata. El incumplimiento puede resultar en:',
    s8_i1: 'Retraso en el pago;',
    s8_i2: 'Cancelación del pago;',
    s8_i3: 'Suspensión de la Plataforma.',
    s8_p2: 'Los Anunciantes pueden impugnar la prueba dentro del plazo de disputa aplicable tras la carga. Si no se presenta impugnación en ese período, la prueba se considerará aceptada.',
    s9: 'Cancelaciones y Reembolsos',
    s9_1: '9.1 Cancelación por el Anunciante',
    s9_1_p1: 'Si un Anunciante cancela:',
    s9_1_i1: 'Antes del período mínimo de aviso del Proveedor de Espacios: elegible para reembolso, menos las tarifas aplicables;',
    s9_1_i2: 'Después del inicio del período de aviso: el reembolso puede denegarse.',
    s9_1_p2: 'Los costes de producción, impresión y preparación pueden no ser reembolsables.',
    s9_2: '9.2 Cancelación por el Proveedor de Espacios',
    s9_2_p1: 'Si un Proveedor de Espacios cancela una reserva confirmada sin motivo válido:',
    s9_2_i1: 'El Anunciante recibirá un reembolso completo;',
    s9_2_i2: 'El Proveedor de Espacios podrá incurrir en penalizaciones, reducción de visibilidad, suspensión o cancelación de cuenta.',
    s9_3: '9.3 Política de Cancelación de Campaña',
    s9_3_i1: 'Las campañas en estado Pendiente pueden cancelarse sin cargo en cualquier momento antes del pago.',
    s9_3_i5: 'Cuando la fecha de cancelación sea anterior al inicio de cada activación de outdoor en más días que el período de preaviso mínimo del Proveedor de Espacios correspondiente, no se aplicará ninguna comisión de cancelación y el Anunciante recibirá el reembolso íntegro de los importes abonados.',
    s9_3_i2: 'Una vez procesado el pago, se aplica una comisión de cancelación del 30% del valor total de la campaña cuando una o más activaciones de outdoor de la campaña se encuentran dentro del período de preaviso mínimo del Proveedor de Espacios correspondiente.',
    s9_3_i3: 'Para empresas registradas en Portugal, se aplicará el tipo de IVA vigente sobre la comisión de cancelación.',
    s9_3_i4: 'Cuando una o más activaciones de outdoor se encuentran dentro del período de preaviso mínimo del Proveedor de Espacios, los costes de instalación e impresión no son reembolsables.',
    s9_3_i6: 'La cancelación de una campaña que ya está en curso conlleva la pérdida del 100% del valor de la campaña. No se emitirá ningún reembolso.',
    s9_3_i7: 'Cuando se aplica la comisión de cancelación del 30%, el 20% del valor total de la campaña se transferirá a los respectivos proveedores de espacios, neto de la comisión estándar del 5% de la plataforma y el IVA aplicable.',
    s9_4: '9.4 Reembolso por emplazamientos no acreditados',
    s9_4_p1: 'En caso de que un Proveedor de Espacios no presente prueba válida de exhibición para uno o más emplazamientos publicitarios en el plazo requerido, Scapow emitirá un reembolso al Anunciante de la siguiente manera:',
    s9_4_i1: 'Por cada día del periodo de la campaña en que un emplazamiento no muestre el creativo del Anunciante, se reembolsará al Anunciante el valor diario proporcional de dicho emplazamiento.',
    s9_4_i4: 'Se aplicará una comisión de cancelación del 10% sobre el importe total reembolsado por los días fallidos, más el IVA aplicable.',
    s9_4_i2: 'Los reembolsos se procesarán en un plazo razonable tras la confirmación de que la prueba de exhibición no ha sido presentada o ha sido declarada inválida.',
    s9_4_i3: 'Las comisiones de servicio de la plataforma aplicables a los emplazamientos acreditados y cumplidos no son reembolsables.',
    s9_5: '9.5 Incumplimiento del Proveedor de Espacio - Cumplimiento Parcial de la Campaña',
    s9_5_p1: 'En caso de que un Proveedor de Espacio no muestre los materiales publicitarios del Anunciante durante la totalidad del período de campaña acordado, cada día en que no se cumpla la obligación de visualización acordada constituirá un "Día de Incumplimiento".',
    s9_5_a: 'a) Responsabilidad Financiera ante Scapow',
    s9_5_p2: 'Por cada Día de Incumplimiento, el Proveedor de Espacio será responsable ante la Plataforma por un importe equivalente a la tarifa de valor publicitario diario aplicable al espacio de campaña correspondiente (el "Importe por Incumplimiento"). La recuperación del Importe por Incumplimiento se efectuará a discreción exclusiva de la Plataforma mediante uno o más de los siguientes medios:',
    s9_5_i1: '(i) exigir al Proveedor de Espacio que remita el Importe por Incumplimiento directamente a la Plataforma dentro del plazo especificado en un aviso escrito emitido por la Plataforma; o',
    s9_5_i2: '(ii) deducir el Importe por Incumplimiento de cualquier pago de campaña presente o futuro que se deba al Proveedor de Espacio, ya sea en el marco de la misma campaña o de cualquier compromiso posterior en la Plataforma.',
    s9_5_p3: 'La Plataforma se reserva el derecho de aplicar ambos recursos de manera simultánea en la medida necesaria para recuperar el Importe por Incumplimiento total en su totalidad.',
    s9_5_b: 'b) Restitución Íntegra al Anunciante',
    s9_5_p4: 'Por cada Día de Incumplimiento, el Anunciante tendrá derecho a un reembolso íntegro de todos los importes pagados por dichos días, incluida la tarifa diaria de campaña correspondiente, cualquier comisión aplicable de la Plataforma y cualquier tarifa de servicio o transacción atribuible a esos días. Dicho reembolso será procesado por la Plataforma en un plazo razonable tras la confirmación del incumplimiento.',
    s9_5_c: 'c) Determinación del Incumplimiento',
    s9_5_p5: 'El incumplimiento del período de visualización acordado se evaluará sobre la base de las pruebas presentadas a través de la Plataforma, incluyendo, entre otras, registros de prueba de colocación, informes de Anunciantes, documentación fotográfica y cualquier otro material que la Plataforma considere pertinente. La determinación de la Plataforma será definitiva y vinculante a efectos del cálculo del Importe por Incumplimiento y la gestión de los reembolsos a los Anunciantes, sin perjuicio de los derechos legales de ambas partes en virtud de la legislación aplicable.',
    s9_6: '9.6 Fuerza Mayor - Desastres Naturales',
    s9_6_p1: 'Un "Evento de Fuerza Mayor" es un desastre natural o una emergencia relacionada, fuera del control razonable del Anunciante y del Proveedor de Espacios, que impida físicamente que un espacio publicitario muestre la creatividad del Anunciante, o haga que hacerlo sea inseguro, incluidos terremotos, inundaciones, tormentas, huracanes, incendios forestales, deslizamientos de tierra, órdenes de evacuación o de emergencia dictadas por las autoridades competentes y cortes de suministro eléctrico causados por dichos eventos. Las condiciones meteorológicas adversas habituales, el desgaste normal y la falta de mantenimiento no constituyen Eventos de Fuerza Mayor.',
    s9_6_a: 'a) Notificación y Pruebas',
    s9_6_p2: 'El Proveedor de Espacios deberá comunicar un Evento de Fuerza Mayor a través de la Plataforma en un plazo de 48 horas desde que tenga conocimiento del mismo, junto con pruebas (como fotografías o alertas oficiales) y una fecha estimada de restablecimiento. La Plataforma evaluará, sobre la base de dichas pruebas, si el evento es admisible; su decisión será definitiva y vinculante a efectos de esta sección.',
    s9_6_b: 'b) Efectos para el Proveedor de Espacios',
    s9_6_i1: 'Cada día en que la exhibición se vea impedida por un Evento de Fuerza Mayor admisible (un "Día de Fuerza Mayor") no constituirá un Día de Incumplimiento conforme a la sección 9.5, y no se adeudará ningún Importe por Incumplimiento respecto del mismo.',
    s9_6_i2: 'No se adeudará ningún pago al Proveedor de Espacios por los Días de Fuerza Mayor.',
    s9_6_i3: 'El Proveedor de Espacios deberá restablecer la exhibición en un plazo de 5 días hábiles tras la finalización del Evento de Fuerza Mayor. Todo día posterior a dicho plazo en que la exhibición no se haya restablecido constituirá un Día de Incumplimiento conforme a la sección 9.5.',
    s9_6_i4: 'El Proveedor de Espacios sigue siendo responsable del mantenimiento y del seguro adecuado de sus estructuras, incluido el coste de reimprimir y reinstalar cualquier material creativo dañado o destruido por el evento.',
    s9_6_c: 'c) Efectos para el Anunciante',
    s9_6_i5: 'El Anunciante tendrá derecho al reembolso íntegro de todos los importes pagados por los Días de Fuerza Mayor, incluida la tarifa diaria de la campaña, la comisión correspondiente de la Plataforma y el IVA aplicable, sin la comisión del 10% a que se refiere la sección 9.4.',
    s9_6_i6: 'Alternativamente, el Anunciante podrá optar por trasladar los días afectados al final de la campaña, sujeto a la disponibilidad del espacio publicitario.',
    s9_6_i7: 'Cuando un espacio publicitario quede indisponible debido a un Evento de Fuerza Mayor antes del inicio de su activación, el Anunciante o el Proveedor de Espacios podrán retirarlo de la campaña sin comisión de cancelación alguna, no obstante lo dispuesto en la sección 9.3, y el Anunciante recibirá el reembolso íntegro de los importes pagados por el mismo.',
    s9_6_i8: 'Cuando un Evento de Fuerza Mayor dure más de 14 días, o más de la mitad del período restante de la campaña en el espacio afectado, el Anunciante podrá cancelar el resto de dicho espacio sin coste y recibir el reembolso de los días restantes.',
    s9_6_i9: 'En las campañas pagadas en cuotas mensuales, las cuotas futuras se reducirán o cancelarán en consecuencia.',
    s9_6_d: 'd) Ámbito',
    s9_6_p3: 'Los eventos que afecten únicamente a la actividad del propio Anunciante, y no a los espacios publicitarios, no están cubiertos por esta sección; se aplica la Política de Cancelación de Campañas de la sección 9.3.',
    s9_7: '9.7 Vandalismo',
    s9_7_p1: '"Vandalismo" significa el daño, la desfiguración o la retirada deliberados de un espacio publicitario o de la creatividad del Anunciante por terceros sin relación con el Anunciante ni con el Proveedor de Espacios, por ejemplo grafitis, carteles rasgados o tapados, o pantallas o estructuras dañadas.',
    s9_7_i1: 'El Proveedor de Espacios deberá comunicar el Vandalismo a través de la Plataforma en un plazo de 48 horas desde que tenga conocimiento del mismo, junto con fotografías y, cuando esté disponible, una denuncia policial.',
    s9_7_i2: 'El Proveedor de Espacios deberá restablecer la exhibición en un plazo de 3 días hábiles desde la comunicación, a su cargo, incluida la reimpresión y reinstalación de la creatividad.',
    s9_7_i3: 'Los días en que la exhibición se vea impedida dentro de dicho plazo de restablecimiento se tratarán como Días de Fuerza Mayor conforme a la sección 9.6: el Anunciante tendrá derecho a su reembolso íntegro, sin comisiones, y no se adeudará ningún Importe por Incumplimiento.',
    s9_7_i4: 'Los días posteriores al plazo de restablecimiento, o el Vandalismo derivado de que el Proveedor de Espacios no haya adoptado medidas preventivas razonables, constituirán Días de Incumplimiento conforme a la sección 9.5.',
    s9_7_i5: 'Cuando el mismo espacio publicitario sea vandalizado tres o más veces en un plazo de 30 días, el Proveedor de Espacios deberá adoptar medidas preventivas razonables, y el Anunciante podrá cancelar el resto de dicho espacio sin coste y recibir el reembolso de los días restantes.',
    s9_7_p2: 'Comunicar un Evento de Fuerza Mayor o un Vandalismo que no se haya producido se considerará presentación de una prueba de exhibición falsa conforme a la sección 12 y podrá dar lugar a la suspensión o cancelación inmediata de la cuenta.',
    proofProtectionNote: 'Su inversión está protegida: si algún emplazamiento exterior no proporciona prueba verificada de exhibición, Scapow le reembolsará el importe correspondiente a ese emplazamiento.',
    s10: 'Disputas',
    s10_p1: 'Los usuarios acuerdan intentar primero la resolución a través de la Plataforma. La Plataforma puede:',
    s10_i1: 'Revisar las pruebas de la campaña;',
    s10_i2: 'Solicitar documentación adicional;',
    s10_i3: 'Emitir una decisión no vinculante.',
    s10_p2: 'La decisión de la Plataforma no reemplaza los derechos legales bajo la ley aplicable.',
    s11: 'Propiedad Intelectual',
    s11_p1: 'Los Anunciantes conservan la propiedad del contenido presentado.',
    s11_p2: 'Al cargar materiales, los Anunciantes conceden a la Plataforma y a los Proveedores de Espacios una licencia limitada y no exclusiva para usar, reproducir y mostrar dichos materiales exclusivamente para ejecutar la campaña.',
    s11_p3: 'Los Proveedores de Espacios conservan la propiedad de sus listados, imágenes y datos de ubicación.',
    s11_p4: 'La Plataforma conserva la propiedad de todo el software, la marca y los sistemas de la plataforma.',
    s12: 'Uso Prohibido',
    s12_p1: 'Los usuarios no pueden:',
    s12_i1: 'Cometer fraude;',
    s12_i2: 'Cargar contenido engañoso o ilegal;',
    s12_i3: 'Eludir pagos;',
    s12_i4: 'Contactar usuarios fuera de la Plataforma para evitar tarifas;',
    s12_i5: 'Manipular reseñas o resultados de campañas;',
    s12_i6: 'Cargar prueba de instalación falsa.',
    s12_p2: 'La infracción puede resultar en suspensión o cancelación inmediata.',
    s13: 'Responsabilidad',
    s13_p1: 'En la máxima medida permitida por la ley, la Plataforma no será responsable por:',
    s13_i1: 'Bajo rendimiento de la campaña;',
    s13_i2: 'Daños meteorológicos, desastres naturales y vandalismo, que se rigen por las secciones 9.6 y 9.7;',
    s13_i3: 'Retrasos causados por terceros;',
    s13_i4: 'Defectos de impresión no causados por la Plataforma;',
    s13_i5: 'Actos u omisiones de los usuarios.',
    s13_p2: 'La responsabilidad total no excederá el total de las tarifas pagadas a la Plataforma por la campaña en cuestión.',
    s14: 'Indemnización',
    s14_p1: 'Los usuarios acuerdan indemnizar y eximir de responsabilidad a la Empresa frente a cualquier reclamación, pérdida, daño, responsabilidad o gasto derivado de:',
    s14_i1: 'Incumplimiento de estos Términos;',
    s14_i2: 'Contenido publicitario ilegal;',
    s14_i3: 'Infracción de derechos de terceros;',
    s14_i4: 'Conducta fraudulenta.',
    s15: 'Suspensión de Cuenta',
    s15_p1: 'La Plataforma puede suspender o cancelar cuentas por:',
    s15_i1: 'Fraude;',
    s15_i2: 'Falta de pago;',
    s15_i3: 'Disputas repetidas;',
    s15_i4: 'Abuso de la Plataforma;',
    s15_i5: 'Violación de estos Términos.',
    s16: 'Impuestos',
    s16_p1: 'Los usuarios son responsables de sus propios impuestos, incluyendo IVA, impuesto sobre ventas, impuesto sobre la renta y cualquier otro impuesto aplicable. La Plataforma puede recaudar impuestos cuando sea legalmente requerido.',
    s17: 'Protección de Datos',
    s17_p1: 'Los datos de los usuarios serán procesados de acuerdo con la Política de Privacidad de la Plataforma y las leyes de protección de datos aplicables. Los usuarios son responsables de garantizar que tienen derechos legales sobre cualquier dato personal cargado.',
    s18: 'Ley Aplicable',
    s18_p1: 'Estos Términos se regirán por las leyes aplicables sin atender a los principios de conflicto de leyes. Las disputas quedarán sujetas a la jurisdicción exclusiva de los tribunales competentes.',
    s19: 'Modificaciones',
    s19_p1: 'La Plataforma puede modificar estos Términos en cualquier momento. El uso continuado de la Plataforma tras las modificaciones constituye aceptación.',
    s20: 'Contacto',
    s20_p1: 'Para consultas legales:',
  },
  team: {
    title: 'Gestión del Equipo',
    subtitle: 'Administra los miembros de tu equipo y envía invitaciones',
    tabUsers: 'Miembros Activos',
    tabInvitations: 'Invitaciones',
    noUsers: 'Aún no hay miembros activos',
    noUsersDesc: 'Los usuarios aparecerán aquí una vez acepten la invitación',
    statusVerified: 'Verificado',
    statusPending: 'Pendiente',
  },
  footer: {
    tagline:
      'El mercado que conecta propietarios de publicidad exterior con anunciantes. Sencillo, eficiente, impactante.',
    platform: 'Plataforma',
    browseOutdoors: 'Explorar Vallas',
    createAccount: 'Crear Cuenta',
    logIn: 'Iniciar Sesión',
    forBusinesses: 'Para Empresas',
    registerBusiness: 'Registrar Empresa',
    listOutdoors: 'Publicar tus Vallas',
    runCampaigns: 'Lanzar Campañas',
    about: 'Sobre',
    howItWorks: 'Cómo Funciona',
    mission: 'Nuestra Misión',
    contactUs: 'Contáctenos',
    copyright: '© 2026 Scapow by Codify. Todos los derechos reservados.',
    privacy: 'Privacidad',
    terms: 'Términos',
  },
  language: {
    select: 'Idioma',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'Verificación de Vallas de Campaña',
    subtitle: 'Envíe fotos de prueba para sus vallas de campaña activas pendientes de verificación. Todos los espacios de una campaña deben tener su prueba enviada para que el pago de la campaña sea desbloqueado.',
    empty: 'Sin verificaciones pendientes',
    emptyDesc: 'Todas sus vallas de campaña activas están al día. Vuelva a consultar una vez que sus campañas estén en marcha.',
    uploadProof: 'Subir foto de prueba',
    uploaded: 'Prueba enviada',
    uploadSuccess: 'Foto de prueba enviada correctamente.',
    noName: 'Valla de Campaña',
    locating: 'Localizando…',
    awaitingVerification: 'Pendiente de verificación',
    verified: 'Verificado',
    partiallyVerified: 'Parcialmente verificado',
    backToCampaigns: 'Volver a las campañas',
    noOutdoors: 'No se encontraron espacios para esta campaña',
    pendingCount: '{{count}} pendiente',
    notYetAvailable: 'Verificación disponible desde el {{date}}',
    viewProof: 'Ver foto de prueba',
    proofAlt: 'Foto de prueba',
    deleteProof: 'Eliminar prueba',
    deleteProofSuccess: 'Foto de prueba eliminada.',
    deleteProofConfirm: '¿Estás seguro de que quieres eliminar esta foto de prueba? Esta acción no se puede deshacer.',
  },
  howItWorksPage: {
    title: 'Cómo Funciona',
    subtitle: 'Ya sea que poseas espacios publicitarios o quieras llegar a nuevas audiencias, Scapow lo hace sencillo.',
    advertiserTab: 'Para Anunciantes',
    ppTab: 'Para Proveedores de Espacios',
    advertiserTitle: 'Llega a Tu Audiencia a Escala',
    advertiserSubtitle: 'Planifica, lanza y rastrea campañas publicitarias exteriores - todo desde una plataforma intuitiva.',
    adStep1Title: 'Descubre los Espacios Adecuados',
    adStep1Desc: 'Navega miles de ubicaciones exteriores verificadas en un mapa interactivo. Filtra por ciudad, formato, dimensiones, disponibilidad y tarifa diaria para encontrar los lugares perfectos para tu campaña.',
    adStep2Title: 'Construye Tu Campaña',
    adStep2Desc: 'Selecciona múltiples vallas y agrúpalas en una sola campaña. Establece tus fechas, sube tus creatividades y confirma tu plan - sin necesidad de agencia.',
    adStep3Title: 'Paga con Confianza',
    adStep3Desc: 'Recibe un desglose de pago transparente antes de confirmar. Paga de forma segura a través de nuestra plataforma y una pasarela de pago segura, y obtén una factura formal - todo documentado y rastreable.',
    adStep4Title: 'Rastrea Cada Colocación',
    adStep4Desc: 'Una vez que tu campaña esté activa, los proveedores de espacios envían prueba fotográfica del exterior. Monitorea el estado y las confirmaciones directamente desde tu panel.',
    ppTitle: 'Convierte Tus Espacios en Ingresos',
    ppSubtitle: 'Lista una vez, llega a miles de anunciantes y gana según tu propio ritmo.',
    ppStep1Title: 'Lista Tus Espacios',
    ppStep1Desc: 'Crea listados detallados para cada una de tus ubicaciones exteriores. Añade dimensiones, fotos, precios y disponibilidad. Cuanto mejor sea tu listado, más campañas atraerás.',
    ppStep2Title: 'Conéctate con Campañas',
    ppStep2Desc: 'Tus espacios aparecen automáticamente en las búsquedas de los anunciantes. Cuando te seleccionen para una campaña, recibirás una notificación y una reserva confirmada - sin negociación.',
    ppStep3Title: 'Sube la Prueba de Exhibición',
    ppStep3Desc: 'Una vez que tu exterior esté mostrando la campaña, sube una prueba fotográfica a través de la plataforma. Esta es tu confirmación de entrega - y activa el proceso de pago.',
    ppStep4Title: 'Recibe el Pago',
    ppStep4Desc: 'Una vez que la prueba de exhibición ha sido enviada para todos los espacios de una campaña, el pago se libera según los términos acordados. Todos sus espacios de la campaña deben estar verificados antes de que se procese el pago - garantizando la entrega completa antes del cobro.',
    ctaTitle: '¿Listo para empezar?',
    ctaSubtitle: 'Únete a miles de empresas que ya crecen con Scapow.',
    ctaAdvertiser: 'Empezar a Anunciar',
    ctaProvider: 'Listar Mis Espacios',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: 'Nuestra Misión',
    subtitle: 'Conectar el mercado de publicidad exterior - para que cada espacio genere impacto y cada campaña encuentre su audiencia.',
    coreTitle: 'Lo Que Nos Mueve',
    coreDesc: 'La industria de la publicidad exterior está fragmentada. Grandes espacios quedan sin reservar. Las campañas no alcanzan su potencial. Creemos que la tecnología puede cambiar eso - y Scapow es el cómo.',
    pillar1Title: 'Ampliar Alcance e Impacto',
    pillar1Desc: 'Permitimos a los anunciantes planificar y ejecutar campañas exteriores de alto impacto en múltiples ubicaciones desde una plataforma unificada - llegando a audiencias a escala sin la carga operativa.',
    pillar2Title: 'Maximizar los Ingresos de los Proveedores',
    pillar2Desc: 'Damos a los proveedores de espacios acceso directo a una cartera calificada de demanda publicitaria, reduciendo el inventario vacante y asegurando que sus espacios generen ingresos consistentes y predecibles.',
    pillar3Title: 'Conectar el Mercado OOH Estático',
    pillar3Desc: 'Estamos construyendo la infraestructura que la industria exterior necesitaba desde hace tiempo - un mercado transparente y digital donde la oferta se encuentra con la demanda de forma eficiente, justa y a escala.',
    pillar4Title: 'Confianza a Través de la Transparencia',
    pillar4Desc: 'Desde la verificación de credenciales empresariales hasta la prueba fotográfica de exhibición, cada paso del proceso Scapow está diseñado para ser auditable, responsable y construido sobre confianza mutua.',
    visionTitle: 'Nuestra Visión',
    visionDesc: 'Un mundo donde cada espacio exterior es una oportunidad - y cada marca puede encontrar su lienzo perfecto, dondequiera que su audiencia viva, trabaje y se mueva.',
    closingTitle: 'Construyendo el Futuro del OOH',
    closingDesc: 'Scapow es más que un mercado. Es el tejido conectivo de la industria de publicidad exterior - reuniendo a proveedores de espacios, anunciantes y la tecnología que impulsa su éxito compartido.',
  },
  contact: {
    label: 'Ponte en Contacto',
    title: 'Contáctenos',
    subtitle: '¿Tienes una pregunta, comentario o simplemente quieres saludar? Nos encantaría saber de ti.',
    infoTitle: 'Hablemos',
    infoDesc: 'Ya sea sobre funcionalidades, precios o cualquier otra cosa - nuestro equipo está listo para responder todas tus preguntas.',
    responseTimeTitle: 'Respuesta Rápida',
    responseTimeDesc: 'Normalmente respondemos en 24 horas.',
    emailTitle: 'Escríbenos',
    whatsappTitle: 'WhatsApp',
    formTitle: 'Envíanos un mensaje',
    fieldName: 'Tu Nombre',
    fieldEmail: 'Tu Email',
    fieldSubject: 'Asunto',
    fieldMessage: 'Mensaje',
    namePlaceholder: 'Juan García',
    emailPlaceholder: 'tu@ejemplo.com',
    subjectPlaceholder: '¿Cómo podemos ayudarte?',
    messagePlaceholder: 'Cuéntanos qué tienes en mente…',
    submit: 'Enviar Mensaje',
    submitting: 'Enviando…',
    successTitle: '¡Mensaje enviado!',
    successDesc: 'Gracias por contactarnos. Estaremos en contacto pronto.',
    backHome: 'Volver al Inicio',
    errorRequired: 'Este campo es obligatorio.',
    errorEmail: 'Por favor introduce un email válido.',
  },
  calendar: {
    calendarMonthsHint: 'Se reserva por meses naturales completos, del día 1 al último. Haga clic en un día 1 para empezar, en un día posterior para añadir su mes o en un día dentro de la reserva para acortarla.',
    startOnMonthFirstHint: 'Las reservas empiezan el día 1 de un mes.',
    fullMonthHint: 'Reserva por meses: elija el día de inicio y haga clic en un día posterior para añadir meses; cada uno termina el mismo día del mes siguiente (empezando un día 1, el último día del mes). Haga clic dentro de la reserva para acortarla.',
    discountsTitle: 'Reserve más tiempo, ahorre más',
    discountTier: '{{days}}+ días',
    discountsPickStart: 'Elija una fecha de inicio para ver qué fechas de fin tienen descuento.',
    discountsHighlighted: 'Cuanto más oscuro el verde, mayor el descuento: las etiquetas muestran dónde empieza cada uno.',
    discountApplied: '{{percentage}}% de descuento en estos {{count}} días',
    discountNextTier: 'Añada {{days}} día(s) más para ahorrar un {{percentage}}%',
    latestStartInfo: 'Fechas de inicio hasta el {{date}}',
    blockedLegend: 'Bloqueado / no disponible',
    pendingLegend: 'Pendiente (aún no guardado)',
    loading: 'Cargando disponibilidad…',
    noticeRequired: 'Fecha de inicio más temprana: {{date}} (se requiere aviso previo de {{count}} días)',
    minimumDaysError: 'El alquiler mínimo es {{count}} días - amplíe su selección',
    overlapError: 'El rango seleccionado abarca fechas reservadas - elige solo días consecutivos disponibles',
  },
  approvals: {
    thisBookingLegend: 'Esta reserva',
    blockedSelection: 'Periodo bloqueado:',
    blockedSelectionEmpty: 'Elija las fechas de inicio y fin en el calendario.',
    title: 'Aprobaciones',
    subtitle: 'Confirme si sus espacios están disponibles para estas campañas pagadas.',
    emptyTitle: 'Está todo al día',
    emptyDesc: 'Cuando un anunciante reserve uno de sus espacios, aparecerá aquí para su aprobación.',
    campaignFallback: 'Campaña',
    outdoorsToReview: 'Espacios por revisar: {{count}}',
    startsOn: 'Empieza el {{date}}',
    answerBy: 'Responder antes del {{date}}',
    review: 'Revisar',
    youEarn: 'Usted gana',
    backToList: 'Volver a aprobaciones',
    reviewEyebrow: 'Solicitud de aprobación',
    summaryLine: 'Espacios: {{count}} · Usted gana {{value}}',
    deadlineNotice: 'Responda antes del {{date}}. Los espacios sin respuesta a tiempo se liberan de la campaña.',
    progress: '{{answered}} de {{total}} respondidos',
    approveAll: 'Aprobar todos',
    available: 'Disponible',
    unavailable: 'No disponible',
    decisionFor: '¿Está {{name}} disponible?',
    decisionRequired: 'Elija una respuesta.',
    blockedHint: 'Indique cuándo está ocupado este espacio: bloquearemos estas fechas.',
    blockedFrom: 'Bloqueado desde',
    blockedTo: 'Bloqueado hasta',
    blockedRequired: 'Las dos fechas son obligatorias.',
    blockedOrder: 'La fecha de fin debe ser igual o posterior a la de inicio.',
    viewCreative: 'Ver la creatividad de {{name}}',
    noCreative: 'Aún sin creatividad',
    feedbackMandatory: 'Se necesita una respuesta para cada espacio.',
    submit: 'Enviar respuestas',
    fixBeforeSubmit: 'Responda a todos los espacios y revise las fechas bloqueadas.',
    confirmTitle: '¿Enviar sus respuestas?',
    confirmSummary: 'Disponibles: {{approved}} · No disponibles: {{unavailable}}',
    confirmNote: 'Las respuestas no se pueden cambiar una vez enviadas.',
    submitted: 'Gracias, sus respuestas se han enviado.',
    submitError: 'No se pudieron enviar sus respuestas.',
    allAnsweredTitle: 'Ya respondido',
    allAnsweredDesc: 'Ya ha respondido por todos sus espacios de esta campaña.',
    loadErrorTitle: 'Esta aprobación no está disponible',
    loadErrorDesc: 'Puede que ya se haya respondido o que la campaña se haya cancelado.',
  },
  status: {
    installment: {
      SCHEDULED: 'Programada',
      PROCESSING: 'En proceso',
      PAID: 'Pagada',
      FAILED: 'Fallida',
      CANCELLED: 'Cancelada',
    },
    campaign: {
      PENDING: 'Borrador',
      AWAITING_PAYMENT: 'Pendiente de pago',
      CONFIRMING: 'Esperando proveedores',
      AWAITING_CONFIRMATION: 'Decisión necesaria',
      READY: 'Confirmada',
      RUNNING: 'En emisión',
      COMPLETED: 'Completada',
      CANCELLED: 'Cancelada',
      UNAVAILABLE: 'No disponible',
    },
    payment: {
      PENDING: 'Sin pagar',
      VALIDATING_PAYMENT: 'Validando pago',
      MANUAL_VALIDATION: 'En revisión',
      TRANSFER_REQUESTED: 'Transferencia solicitada',
      PAID: 'Pagado',
      CANCELLED: 'Cancelado',
      PARTIALLY_REFUNDED: 'Reembolsado parcialmente',
      FULLY_REFUNDED: 'Reembolsado',
      FAILED: 'Fallido',
    },
    campaignOutdoor: {
      PENDING: 'Esperando prueba',
      VERIFYING: 'Verificando prueba',
      FOR_MANUAL_APPROVAL: 'Prueba en revisión',
      APPROVED: 'Prueba aprobada',
      REJECTED: 'Prueba rechazada',
      REFUNDED: 'Reembolsado',
      CANCELLED: 'Cancelado',
    },
    proof: {
      PENDING: 'Pendiente',
      VALID: 'Válida',
      MANUAL_VALIDATION: 'En revisión',
      INVALID: 'No válida',
    },
    paymentType: {
      BUYING_ADS: 'Compra de publicidad',
      SELLING_ADS: 'Pago al proveedor',
      REFUND_BUYING_PART: 'Reembolso al anunciante',
      REFUND_SELLING_PART: 'Reembolso del proveedor',
      PLACEMENT_PROVIDER_DEBT: 'Deuda del proveedor',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'Compensación por cancelación',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'Creatividades',
    creativesSubtitle: 'Artes a instalar. Sirve cualquier medida: usted decide cómo encaja en cada espacio.',
    uploadCreatives: 'Subir creatividades',
    noCreatives: 'Aún no hay creatividades. Haga clic para subir archivos JPG, PNG, TIFF o PDF.',
    creativesUploaded: 'Creatividades subidas.',
    creativeRemoved: 'Creatividad eliminada.',
    removeCreative: 'Eliminar creatividad',
    removeCreativeConfirm: '¿Eliminar esta creatividad? No se puede deshacer.',
    downloadOriginal: 'Descargar original',
    filesTitle: 'Archivos',
    filesSubtitle: 'Contratos, briefings o cualquier otro archivo de esta campaña.',
    uploadFiles: 'Subir archivos',
    noFiles: 'Aún no se han subido archivos.',
    filesUploaded: 'Archivos subidos.',
    fileRemoved: 'Archivo eliminado.',
    removeFile: 'Eliminar archivo',
    removeFileConfirm: '¿Eliminar «{{name}}»? No se puede deshacer.',
    download: 'Descargar',
    remove: 'Eliminar',
    outdoorsTitle: 'Espacios',
    noOutdoors: 'Esta campaña aún no tiene espacios.',
    modalTitle: 'Añadir a una campaña offline',
    newTitle: 'Nueva campaña offline',
    pickTitle: 'Elegir una campaña offline',
    datesTitle: 'Elija las fechas',
    doneTitle: 'Espacio añadido',
    forOutdoor: 'Espacio:',
    optionNew: 'Nueva',
    optionNewDesc: 'Cree una campaña para una reserva vendida fuera de Scapow.',
    optionPick: 'Elegir existente',
    optionPickDesc: 'Añádalo a una de sus campañas offline.',
    name: 'Nombre de la campaña',
    nameRequired: 'Ponga un nombre a la campaña.',
    details: 'Detalles',
    detailsHint: 'P. ej., el cliente o el canal por el que se vendió.',
    notes: 'Notas',
    notesHint: 'Notas internas: solo visibles para su equipo.',
    instructions: 'Instrucciones',
    instructionsHint: 'Para quien instale la creatividad.',
    createAndContinue: 'Crear y continuar',
    createError: 'No se pudo crear la campaña offline.',
    addError: 'No se pudo añadir el espacio a la campaña.',
    noneYet: 'Aún no tiene campañas offline.',
    outdoorsCount: 'Espacios: {{count}}',
    createdOn: 'creada el {{date}}',
    datesIntro: 'Elija cuándo está reservado el espacio para «{{campaign}}». Las fechas ya ocupadas se muestran y no se pueden seleccionar.',
    pickDates: 'Elija las fechas de inicio y fin en el calendario.',
    addToCampaign: 'Añadir a la campaña',
    doneMessage: '{{outdoor}} se ha añadido a «{{campaign}}».',
    doneHint: 'Estas fechas quedan bloqueadas para otras reservas.',
    backToSearch: 'Volver a la búsqueda',
    getAvailability: 'Ver disponibilidad',
    clearAvailability: 'Quitar disponibilidad',
    availabilityTitle: 'Ver disponibilidad',
    availabilityHint: 'Elija una fecha de inicio y de fin para ver solo los espacios libres durante todo el periodo.',
    showAvailable: 'Mostrar espacios disponibles',
    dimensionsLabel: 'Medidas',
    noMatches: 'Ningún espacio coincide con estos filtros',
    noMatchesHint: 'Pruebe otras medidas o fechas, o quite los filtros.',
    clearFilters: 'Quitar filtros',
    addButton: 'Añadir a campaña offline',
    addTooltip: 'Añadir a una campaña no reservada a través de Scapow',
  },
};

export default es;
